import {
    Button,
    Card,
    Col,
    Drawer,
    Form,
    Icon,
    Input,
    notification,
    Row,
    Spin,
    Table,
    Tooltip,
    Descriptions,
    Badge,
    Select,
    Popconfirm,
    Tag
} from 'antd'
import { UploadOutlined } from '@ant-design/icons';
import { FaDownload } from 'react-icons/fa';
import _ from 'lodash'
import moment from 'moment'
import Moment from "moment";
import React from 'react'
import { connect } from 'react-redux'
//import GetAllFormFields from '../../../../components/_utils/formUtils'
import { FormUtils as GetAllFormFields } from 'sz-react-utils'
import PageHeaderWrapper from '../../../../components/PageHeaderWrapper'
import StudentHeader from '../../../../components/studentHeader'
import StudentInfo from '../../../../components/StudentInfo'
import rightAuth from '../../../../components/_utils/userRights'
import ShowGeneratedInvoice from '../../../../components/pdf/showGeneratedInvoice'
import { hideLoader, showLoader } from '../../../../modules/actions'
import Request, { API_URL, LAPI_URL, MEDIA_URL } from '../../../../request'
import { getUrlPushWrapper } from '../../../../routes'
import GenerateInvoice from '../claimProcessing/generateInvoice'
import UpdateInvoice from '../claimProcessing/updateGenerateInvoice'
import styles from './styles.less'
import InboxEmailView from '../../../../components/Invoice/inboxEmailView';
import userRights from "../../../../components/_utils/userRights"
import PDFFileView from '../../../../components/DocumentViews/PDFFileView'
import { RightsWrapper } from '../../../../components/_utils/utils';
import WithdrawStudentReasonForm from '../../../../components/Invoice/withdrawStudentReasonForm';
let dateFormat = localStorage.getItem('company-details') ? JSON.parse(localStorage.getItem('company-details')).dateFormat : 'DD.MM.YYYY';
let companyDetail = localStorage.getItem('company-details') ? JSON.parse(localStorage.getItem('company-details')) : {};
const showChannelPartner = userRights.getUserAuth('showChannelPartner');
let sourceOptions = ["Direct", "Associate Partner"];
const Option = Select.Option
const activeUser = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {};


@Form.create()
class ChangeAp extends React.Component {
    state = {
        visible: true,
        associatePartners: [],
        showAssociatePartners: false
    }

    onClose = () => {
        this.setState({ visible: false })
        setTimeout(() => {
            this.props.onClose()
        }, 400)
    }


    loadAssociativePartner = async () => {
        let params = {
            status: true,
            branchAssociatePartner: "Associate Partner",
            sortField: "branchName",
            results: 1000,
        };
        let data = await Request.loadSimpleBranch({ ...params });
        let associatePartners = []
        _.each(data.data, (partner) => {
            associatePartners.push({ id: partner._id, display: partner.branchName })
        })
        this.setState({ associatePartners })
    }




    handleSubmit = (e) => {
        let { form, inquiryId } = this.props
        e.preventDefault()
        form.validateFieldsAndScroll(async (err, valData) => {
            let values = _.clone(valData)
            values.inquiryId = inquiryId;
            if (!values.associativePartnerId) {
                values.associativePartnerId = ''
            }
            let response = await Request.changeAssociativePartner(values)
            if (response.success) {
                notification.success({
                    message: response.message
                })
            } else {
                notification.error({
                    message: 'Something Went Wrong'
                })
            }
            this.onClose()
        })
    }

    loadInquiry = async () => {
        let { inquiryId } = this.props
        let { doc } = await Request.getInquiry(inquiryId);
        if (doc.location === "Associate Partner") {
            this.setState({ showAssociatePartners: true })
        }
        this.props.form.setFieldsValue(doc)
    }

    componentDidMount() {
        this.loadAssociativePartner()
        this.loadInquiry()
    }

    render() {
        let { visible } = this.state
        let { form: { getFieldDecorator } } = this.props
        const inputTypes = {
            fields: [
                {
                    label: 'Source',
                    key: 'location',
                    type: 'select',
                    options: sourceOptions,
                    onChange: v => {
                        this.props.form.setFieldsValue({ location: v })
                        if (v === "Associate Partner") {
                            this.setState({ showAssociatePartners: true })
                        } else {
                            this.setState({ showAssociatePartners: false })
                        }
                    }
                },
                {
                    label: 'Users',
                    key: 'associativePartnerId',
                    type: 'select',
                    showSearch: true,
                    hidden: !this.state.showAssociatePartners,
                    required: this.state.showAssociatePartners,
                    options: this.state.associatePartners,
                    onChange: v => {
                        this.props.form.setFieldsValue({ associativePartnerId: v })
                    }
                }
            ]
        }
        return (
            <Drawer
                title={
                    <div>
                        <React.Fragment>Update Associate Partner</React.Fragment>
                    </div>
                }
                placement="right"
                closable={true}
                onClose={this.onClose}
                width={800}
                visible={visible}
            >
                <Card>
                    <Form onSubmit={this.handleSubmit}>
                        <GetAllFormFields inputSchema={inputTypes} getFieldDecorator={getFieldDecorator} apiurl={LAPI_URL} />
                        <Row>
                            <Col span={8} />
                            <Col span={8}>
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    style={{ marginBottom: 10 }}
                                    loading={this.props.loading}
                                >
                                    SAVE
                                </Button>
                            </Col>
                            <Col span={8} />
                        </Row>
                    </Form>
                </Card>
            </Drawer>
        )
    }
}

@Form.create()
class ChangeCp extends React.Component {
    state = {
        visible: true,
        channelPartners: [],
        selectedCourse: {},
    }

    onClose = () => {
        this.setState({ visible: false })
        setTimeout(() => {
            this.props.onClose()
        }, 400)
    }


    loadChannelPartners = async () => {
        let { selectedCourse } = this.state;
        let response = await Request.loadChannelPartnerByUniversityID({ uniId: selectedCourse.universityId });
        let channelPartners = []
        _.each(response.channelPartners, (partner) => {
            channelPartners.push({ id: partner._id, display: partner.channelPartnerName });
        })
        this.setState({ channelPartners })
    }

    loadInquiry = async () => {
        let { inquiryId } = this.props
        let { doc } = await Request.getInquiry(inquiryId);
        // this.setState({selectedCourse:doc.visaDesk.selectedCourse});
        this.setState({ selectedCourse: doc.visaDesk.selectedCourse }, () => {
            this.props.form.setFieldsValue({ channelPartnerId: doc && doc.visaDesk && doc.visaDesk.selectedCourse && doc.visaDesk.selectedCourse.channelPartnerId ? doc.visaDesk.selectedCourse.channelPartnerId : null });
            this.loadChannelPartners();
        })
    }


    handleSubmit = (e) => {
        let { form } = this.props;
        let { channelPartners } = this.state;
        e.preventDefault();
        form.validateFieldsAndScroll(async (err, valData) => {
            let values = _.clone(valData);
            let findChannelPartnerName = _.find(channelPartners, (item) => {
                return item.id === values.channelPartnerId
            })
            values.channelPartnerName = findChannelPartnerName.display;
            values.inquiryId = this.props.inquiryId;
            let response = await Request.changeChannelPartner(values);
            if (response.success) {
                notification.success({
                    message: response.message
                })
            } else {
                notification.error({
                    message: 'Something Went Wrong'
                })
            }
            this.onClose()

        })
    }


    componentDidMount() {
        this.loadInquiry()
    }

    render() {
        let { visible, channelPartners } = this.state;
        let { form: { getFieldDecorator } } = this.props;
        const inputTypes = {
            fields: [
                {
                    label: 'Channel Partner',
                    key: 'channelPartnerId',
                    type: 'select',
                    options: channelPartners,
                    onChange: v => {
                        this.props.form.setFieldsValue({ channelPartnerId: v })
                    }
                },
            ]
        }
        return (
            <Drawer
                title={
                    <div>
                        <React.Fragment>Update Channel Partner</React.Fragment>
                    </div>
                }
                placement="right"
                closable={true}
                onClose={this.onClose}
                width={800}
                visible={visible}
            >
                <Card bordered={true}>
                    <Form onSubmit={this.handleSubmit}>
                        <GetAllFormFields inputSchema={inputTypes} getFieldDecorator={getFieldDecorator} apiurl={LAPI_URL} />
                        <Row>
                            <Col span={8} />
                            <Col span={8}>
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    style={{ marginBottom: 10 }}
                                    loading={this.props.loading}
                                >
                                    SAVE
                                </Button>
                            </Col>
                            <Col span={8} />
                        </Row>
                    </Form>
                </Card>
            </Drawer>
        )
    }
}

@Form.create()
class ClaimProcessing extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            invoiceDates: [],
            showGenerateButton: false,
            loader: true,
            visible1: false,
            visible2: false,
            allow: false,
            drawerInvoiceSettings: false,
            universityId: undefined,
            invoiceButtonLoading: false,
            branchData: {},
            totalInvoice: 0,
            commissionStatus: '',
            editItem: [],
            generatedInvoice: null,
            universityData: {},
            ext: null,
            linkUrl: null,
            showGeneratedInvoiceData: false,
            uploaded: false,
            showGeneratedCPInvoiceData: false,
            currentEditRecord: null,
            loading: false,
            invoiceGeneratedId: '',
            associatePartners: [],
            showApChangeDrawer: false,
            showCpChangeDrawer: false,
            showInvoiveInboxView: false,
            invoiceId: '',
            // branchShareAmount:0,
            branchShare: 0,
            bankDetails: [],
            channelPartnerAgreement: [],
            channelPartnerAgreementCommission: [],
            showWithdrawForm: false,
            enableBTN: false,
            recordId: null,
            invoiceGenerationRecord: {},
            branchPlan: {},
            finalOfferLetter: null,
            studentBranchPlan: {},
        }
        this.loadUserRights()
        this.loadBranchPlan();
    }

    state = {
        loading: true,
        visible: false
    }

    handleConversionCalculation = (value, field) => {
        const { form } = this.props;

        const commission =
            field === 'commReceived'
                ? value
                : form.getFieldValue('commReceived');

        const rate =
            field === 'conversionRate'
                ? value
                : form.getFieldValue('conversionRate');

        if (commission && rate) {
            form.setFieldsValue({
                conversionRate: rate,
                totalAfterConversion: (
                    parseFloat(commission) * parseFloat(rate)
                ).toFixed(2)
            });
        } else {
            form.setFieldsValue({
                totalAfterConversion: undefined
            });
        }
    };


    handleSubmit = e => {
        const { dispatch, form } = this.props
        e.preventDefault()
        form.validateFieldsAndScroll(async (err, valData) => {
            if (!err) {
                const { inquiryId, invoiceDates, dueInvoiceId } = this.state
                let x
                let values = _.clone(valData);
                dispatch(showLoader())
                _.each(invoiceDates, (item, key) => {
                    item.invoiceNo = key + 1
                })
                values.nextInvoiceGenerationDates = invoiceDates
                values._id = inquiryId
                if (values.status) {
                    let obj = {
                        comment: values.comment,
                        status: values.status,
                        dueInvoiceId: dueInvoiceId,
                        _id: inquiryId,
                        branchCommission: values.branchCommission
                    }
                    x = await Request.updateDueInvoiceStatus(obj)

                } else {
                    x = await Request.updateClaimData(values)
                }
                dispatch(hideLoader())
                if (!x.error) {
                    notification.success({
                        message: 'Success',
                        description: x.msg
                    })
                    this.setAgain(x && x.doc)
                    this.props.form.setFieldsValue({ status: '' })
                    this.setState({ editItem: [], visible: false, showBranchCommission: false, changeStatusValue: false })

                } else {
                    notification.error({
                        message: 'Error Saving',
                        description: x.msg
                    })
                }
            }
        })
    }

    setFormValues = async inquiryId => {
        try {

            let { doc } = await Request.getInquiry(inquiryId)

            if (doc) {
                this.setState({ info: doc, visaDesk: doc.visaDesk, loading: false, loader: false })
            }

        } catch (e) {
            console.log(e)
        }
    }

    getStudentStatus = (info) => {

        if (info && info.nextInvoiceGenerationDates) {
            let foundWithDrawn = info.nextInvoiceGenerationDates.find(obj => {
                return obj.withdrawRequest === true;
            });
            if (foundWithDrawn) {
                return { label: "Withdrawn", color: "red" };
            }
        }

        if (info && info.enrolledInUniversity) {
            return { label: "Enrolled", color: "green" };
        }

        return { label: "Not Enrolled", color: "#FFCC00" };
    };

    sendInvoice = (invoiceId) => {
        this.setState({ showInvoiveInboxView: true, invoiceId: invoiceId });
    }

    loadUserRights = async () => {
        let { userRights } = await Request.loadUserRights()
        this.setState({ claimDeskRights: userRights.ClaimDesk })
    }

    loadBranchPlan = async () => {
        let response = await Request.getBranchDetails();
        if (response && response.doc && response.doc.planDetails && response.doc.planDetails.planCommission && response.doc.planDetails.planCommissionType) {
            this.setState({ branchPlan: { commission: response.doc.planDetails.planCommission, commissionType: response.doc.planDetails.planCommissionType } });
        }
    }

    getStudentBranchPlan = async (branchId) => {
        const finalBranchId = branchId && typeof branchId === 'object' ? (branchId._id || branchId.id) : branchId;
        let response = await Request.getBranchDetails({ branchId: finalBranchId });
        if (response && response.doc && response.doc.planDetails && response.doc.planDetails.planCommission && response.doc.planDetails.planCommissionType) {
            this.setState({ studentBranchPlan: { commission: response.doc.planDetails.planCommission, commissionType: response.doc.planDetails.planCommissionType } });
        }
    }

    downloadFile() {
        let cloneCountryArr = _.clone(this.state.countryArr)
        if (cloneCountryArr[this.state.checkListIndex]) {
            if (cloneCountryArr[this.state.checkListIndex].checkList) {
                let checkListValue = cloneCountryArr[this.state.checkListIndex].checkList
                let offerurl = LAPI_URL + checkListValue
                window.open(offerurl, '_blank')
            } else {
                notification.error({
                    message: 'CheckList',
                    description: `Sorry, ${cloneCountryArr[this.state.checkListIndex].display} Checklist not available.`
                })
            }
        } else {
            notification.error({
                message: 'CheckList',
                description: 'Please choose Country.'
            })
        }
    }

    showDrawer = () => {
        this.setState({
            visible: true
        })
    }
    showDrawer1 = () => {
        this.setState({
            visible1: true
        })
    }
    setAgain = async (doc) => {

        if (doc) {
            let { doc: branchData } = await Request.getBranch(doc.studentBranchId && doc.studentBranchId)

            this.setState({ branchData })
            _.each(doc.nextInvoiceGenerationDates, (item) => {
                let found = _.find(doc.generatedInvoices, (ii) => {
                    return moment(item.generationDate).format('DD-MMM-YYYY') === moment(ii.invoiceGenerationDate).format('DD-MMM-YYYY')

                })
                if (found) {
                    item.showDelete = true
                    if (found.invoiceGenerationStatus === 'Pending') {
                        this.setState({
                            showGenerateButton: true,
                            invoiceId: found._id

                        })
                    } else {
                        this.setState({
                            showGenerateButton: false
                        })
                    }
                }
            })
            if (this.state.claimDeskRights && this.state.claimDeskRights.viewByBranch) {
                doc.dueInvoices = _.filter(doc.dueInvoices, (item) => {
                    return (item.invoiceNo === 1 || item.invoiceNo === 2)
                })

            }
            this.setState({
                inquiryId: doc._id,
                invoiceDates: doc.nextInvoiceGenerationDates && doc.nextInvoiceGenerationDates.length ? doc.nextInvoiceGenerationDates : [],
                branchCommissionValue: branchData && branchData.commission
            })
            this.props.form.setFieldsValue({
                studentStatus: doc.studentStatus,
                arrivalDate: doc.visaDesk && doc.visaDesk.arrivalDate ? moment(doc.visaDesk.arrivalDate) : ''
            })

            this.setFormValues(doc._id)
        }
    }
    showDrawer2 = () => {
        this.setState({
            visible2: true
        })
    }


    getUniversityData = async (universityId) => {
        let { doc: universityData } = await Request.getUniversity(universityId);
        return universityData;

    }

    loadInquiry = async (inquiryId) => {
        let { doc } = await Request.getInquiry(inquiryId);
        if (doc && doc.studentBranchId) {
            this.getStudentBranchPlan(doc && doc.studentBranchId);
        }
        if (doc && doc.visaDesk && doc.visaDesk.selectedCourse && doc.visaDesk.selectedCourse.universityId) {
            let response = await Request.getuniversityCommissionsInquiryId({ id: inquiryId });
            // let response = await Request.getuniversityCommissionsByUniversityID({ id: doc.visaDesk.selectedCourse.universityId });
            this.setState({ totalInvoice: response.totalInvoice, commissionStatus: response.status });
        }
        let allow = rightAuth.checkRights('ClaimDesk.view') && !rightAuth.checkRights('ClaimDesk.viewByBranch')
        if (inquiryId) {

            if (doc) {

                let { doc: branchData } = await Request.getBranch(doc.studentBranchId && doc.studentBranchId._id);
                let branchResponse = await Request.planDetailsByID({ id: branchData.plan });
                this.setState({ branchData, branchShare: parseFloat(branchResponse && branchResponse.doc && branchResponse.doc.planCommission) });
                let channelPartnerId = doc.visaDesk && doc.visaDesk && doc.visaDesk.selectedCourse && doc.visaDesk.selectedCourse.channelPartnerId;
                if (channelPartnerId) {
                    let { doc: channelPartner } = await Request.getPartner(channelPartnerId)
                    this.setState({ channelPartnerAgreement: channelPartner.paymentUpload ? channelPartner.paymentUpload : [], channelPartnerAgreementCommission: channelPartner.paymentUploadCommissionPage ? channelPartner.paymentUploadCommissionPage : [] })
                }

                let universityId = doc.visaDesk && doc.visaDesk.selectedCourse && doc.visaDesk.selectedCourse.universityId
                let courseId = doc.visaDesk && doc.visaDesk.selectedCourse && doc.visaDesk.selectedCourse.courseId
                let universityData = await this.getUniversityData(universityId);
                this.setState({ universityData })
                let applicationDeskCourses = doc && doc.applicationsDesk && doc.applicationsDesk.course ? doc.applicationsDesk.course : null;
                let foundCourse = applicationDeskCourses.filter((course) => {
                    return course.courseId === courseId;
                });
                foundCourse = foundCourse[0];
                let finalOfferLetter = foundCourse && foundCourse.stage2 && foundCourse.stage2.offerUpload ? [foundCourse.stage2.offerUpload] : null;
                if (doc.leadSource === 'Channel Partner') {
                    let { doc: channelPartner } = await Request.getPartner(channelPartnerId)
                    this.setState({
                        commissionValue: channelPartner && channelPartner.commission,
                        channelPartnerName: channelPartner && channelPartner.channelPartnerName,
                        finalOfferLetter
                    })
                } else {
                    this.setState({ commissionValue: universityData && universityData.commission, finalOfferLetter })

                }

                _.each(doc.nextInvoiceGenerationDates, (item) => {
                    let found = _.find(doc.generatedInvoices, (ii) => {
                        return moment(item.generationDate).format('DD-MMM-YYYY') === moment(ii.invoiceGenerationDate).format('DD-MMM-YYYY')

                    })
                    if (found) {
                        item.showDelete = true
                        if (found.invoiceGenerationStatus === 'Pending') {
                            this.setState({
                                showGenerateButton: true,
                                invoiceId: found._id

                            })
                        }
                    }
                })
                if (this.state.claimDeskRights && this.state.claimDeskRights.viewByBranch) {
                    doc.dueInvoices = _.filter(doc.dueInvoices, (item) => {
                        return (item.invoiceNo === 1 || item.invoiceNo === 2)
                    })

                }

                let invoiceDates = doc.nextInvoiceGenerationDates && doc.nextInvoiceGenerationDates.length ? doc.nextInvoiceGenerationDates : [];
                this.setState({
                    inquiryId: inquiryId,
                    universityId,
                    invoiceDates: invoiceDates,
                    branchCommissionValue: branchData && branchData.commission,
                    info: doc, visaDesk: doc.visaDesk,
                    loader: false,
                    allow
                })
                if (doc.visaDesk && doc.visaDesk.courseStartDate) {
                    let $this = this;
                    if (invoiceDates.length > 0) {
                        let invoiceIndex = invoiceDates.length;
                        $this.props.form.setFieldsValue({ nextInvoiceDate: Moment(invoiceDates[invoiceIndex - 1].generationDate).add(5, 'months') });
                    } else {
                        $this.props.form.setFieldsValue({ nextInvoiceDate: Moment(doc.visaDesk.courseStartDate).add(30, 'days') });
                    }
                }
            }

        } else {
            this.setState({ loader: false })
        }

    }

    loadCompanyDetails = async () => {
        let { data } = await Request.getCompanyDetails({ options: "all", });

        data = data && data.reduce((temp, vv) => {
            temp.push({ _id: vv._id, display: vv.companyName });
            return temp;
        }, []);
        this.setState({ bankDetails: data });
    }



    async componentDidMount() {
        let searchParams = new URLSearchParams(this.props.search)
        let inquiryId = searchParams.get('id')
        this.loadInquiry(inquiryId)
        this.loadCompanyDetails();
    }

    checkUrlExt = (url) => {
        return url.split(/[#?]/)[0].split('.').pop().trim();
    }
    renderStatus = (record) => {
        let val = 'Ongoing';
        if (record.atLevel == 'Operation Manager Desk') {
            val = 'Not Enrolled Yet';
        } else if (record.atLevel == 'Front Desk') {
            val = 'Ongoing';
        } else if (['Registration Desk', 'Application Desk', 'Visa Desk'].includes(record.atLevel)) {
            val = 'Enrolled Now';
        } else if (record.atLevel == 'Claim Desk') {
            val = 'To Be Invoiced';
            let term = 0;
            if (record.nextInvoiceGenerationDates && record.nextInvoiceGenerationDates.length > 0) {
                record.nextInvoiceGenerationDates.map((generatedDate, index) => {
                    if (generatedDate.invoiceGenerated == true && generatedDate.invoiceGeneratedNumber) {
                        term = generatedDate.invoiceNo;
                    }
                })
                if (term > 0) {
                    if (record.nextInvoiceGenerationDates.length == term) {
                        val = 'Max Commission Paid';
                    } else {
                        val = 'Invoice Processed-Term ' + term;
                    }
                } else {
                    val = 'To Be Invoiced';
                }
            }
        } else if (record.atLevel == 'Archive Desk') {
            val = 'Max Commission Paid';
        } else if (['Dead Inquiry', 'Deleted'].includes(record.atLevel)) {
            val = 'Withdrawn - Bad Debts';
        }

        if (val === 'Ongoing' || val === 'Invoice Processed-Term 1' || val === 'Enrolled Now') {
            return <div className={styles.Ongoing}>{val}</div>
        }
        if (val === 'Not Enrolled Yet' || val === 'Invoice Processed-Term 4') {
            return <div className={styles.notEnrolled}>{val}</div>
        }

        if (val === 'Max Commission Paid' || val === 'Commission Paid Done' || val === 'Invoice Processed-Term 2') {
            return <div className={styles.maxCommission}>{val}</div>
        }

        if (val === 'Withdrawn - Bad Debts' || val === 'Invoice Processed-Term 3') {
            return <div className={styles.withdrawn}>{val}</div>
        }
        if (val === 'To Be Invoiced') {
            return <div className={styles.Invoiced}>{val}</div>
        }
        if (val === 'Invoice Processed-Term 5') {
            return <div className={styles.Term5}>{val}</div>
        }
    }
    viewPDF = e => {

        let paymentUpload = e;
        if (paymentUpload.length > 0) {

            let linkUrl = MEDIA_URL + paymentUpload[0].url;

            let ext = linkUrl ? this.checkUrlExt(linkUrl) : null;
            if (this.checkUrlExt(linkUrl)) {
                this.setState({ ext: ext, linkUrl: linkUrl });
            } else {
                notification.warning({
                    message: 'Agreement not exists!!!.'
                })
            }
        }
    }
    closeDocument = () => {
        this.setState({ ext: null, linkUrl: null });
    }

    closeChangeAp = () => {
        this.setState({ showApChangeDrawer: false }, () => {
            this.loadInquiry(this.state.inquiryId)
        })
    }
    closeChangeCp = () => {
        this.setState({ showCpChangeDrawer: false }, () => {
            this.loadInquiry(this.state.inquiryId)
        })
    }
    loadInvoiceDetail = async (invoiceId) => {
        const res = await Request.getInvoiceDetail(invoiceId);
        if (!res.error) {
            this.setState({ generatedInvoice: res.doc });
        }
    }

    showChangeAP = async (inquiryId) => {
        this.setState({ showApChangeDrawer: true })
    }

    showChangeCP = async () => {
        this.setState({ showCpChangeDrawer: true });
    }

    handleRemoveCP = async (inquiryId) => {
        let response = await Request.removeChannelPartner({ inquiryId });
        if (response.success) {
            notification.success({
                message: response.message
            })
        } else {
            notification.error({
                message: response.message
            })
        }
        window.location.reload()
    }

    changeAssociativePartner = async (partnerId, inquiryId) => {
        let response = await Request.changeAssociativePartner({
            inquiryId: inquiryId,
            associativePartnerId: partnerId
        })
        if (response.success) {
            notification.success({
                message: response.message
            })
        } else {
            notification.error({
                message: response.message
            })
        }
        window.location.reload()
    }

    handleSubmitCPInvoice = e => {
        const { dispatch, form } = this.props
        e.preventDefault()
        form.validateFieldsAndScroll(async (err, valData) => {
            if (!err) {
                valData.studentId = this.state.inquiryId;
                valData.invoiceGeneratedId = this.state.invoiceGeneratedId;
                this.setState({ loading: true })
                let response = await Request.updateCPinvoiceInfo(valData);
                this.setState({ loading: false })
                if (response.error) {
                    notification.error({
                        message: 'Error Saving',
                        description: 'Error while saving Data'
                    })
                } else {
                    notification.success({
                        message: 'Success',
                        description: 'Saved Successfully'
                    })
                    this.loadInquiry(this.state.inquiryId)
                    this.setState({
                        showGeneratedCPInvoiceData: false,
                        studentId: '',
                        invoiceGeneratedId: '',
                        uploaded: false
                    })
                }
            }
        })
    }

    getIdString(id) {
        if (!id) return null;

        // Case: { $oid: "..." }
        if (typeof id === 'object' && id.$oid) {
            return id.$oid;
        }

        // Case: ObjectId or string
        return id.toString();
    }



    deleteIndex = (index) => {

    }

    resetInvoiceTerm = async (record, info) => {
        const payload = {
            inquiryId: info._id,
            termNumber: record.invoiceNo,
            invoiceGeneratedNumber: record.invoiceGeneratedNumber
        };
        this.setState({ loading: true });
        let response = await Request.resetInvoiceTerm(payload);
        this.setState({ loading: false });
        if (response.error) {
            notification.error({
                message: 'Error',
                description: (response.e && response.e.message) || 'Error while resetting Invoice Term'
            });
        } else {
            notification.success({
                message: 'Success',
                description: response.message || 'Invoice details removed successfully'
            });
            this.loadInquiry(info._id);
        }
    }

    handleSubmitAPInvoice = e => {
        const { dispatch, form } = this.props
        e.preventDefault()
        form.validateFieldsAndScroll(async (err, valData) => {
            if (!err) {
                valData.studentId = this.state.inquiryId;
                valData.invoiceGeneratedId = this.state.invoiceGeneratedId;
                this.setState({ loading: true })
                let response = await Request.updateAPinvoiceInfo(valData);
                this.setState({ loading: false })
                if (response.error) {
                    notification.error({
                        message: 'Error Saving',
                        description: 'Error while saving Data'
                    })
                } else {
                    notification.success({
                        message: 'Success',
                        description: 'Saved Successfully'
                    })
                    this.loadInquiry(this.state.inquiryId)
                    this.setState({
                        showGeneratedInvoiceData: false,
                        studentId: '',
                        invoiceGeneratedId: '',
                    })
                }
            }
        })
    }


    withdrawStudent = async (data) => {
        if (!data.withdrawReason) {
            return notification.error({
                message: 'Please enter withdraw reason.'
            })
        }
        let invoiceGenerationRecord = data;
        data.invoiceGeneratedRecordId = invoiceGenerationRecord._id
            ? (typeof invoiceGenerationRecord._id === "object" && invoiceGenerationRecord._id.$oid
                ? invoiceGenerationRecord._id.$oid
                : invoiceGenerationRecord._id)
            : null;
        data.recordId = data.recordId._id;
        let response = await Request.withdrawStudent(data);
        if (!response.error) {
            if (this.table && this.table.current) {
                this.table.current.reload();
            }
            this.setState({ showWithdrawForm: false })
            notification.success({ message: response.msg });
        } else {
            notification.error({
                message: 'Error withdraw student.'
            })
        }
    }

    closeWithdrawFrom = () => {
        this.setState({ showWithdrawForm: false });
    }


    render() {
        let { filteredInfo, allow, totalInvoice } = this.state
        filteredInfo = filteredInfo || {}
        const { dispatch, form } = this.props
        const {
            form: { getFieldDecorator }
        } = this.props


        const {
            info,
            visaDesk,
            singleDueInvoice,
            claimDeskRights,
            branchCommissionValue,
            invoiceDates,
            inquiryId,
            branchData,
            editItem = [],
            universityData,
            channelPartnerAgreement,
            channelPartnerAgreementCommission,
            ext,
            linkUrl,
            generatedInvoice,
            showGeneratedInvoiceData,
            showGeneratedCPInvoiceData,
            invoiceId,
            showWithdrawForm,
            enableBTN,
            recordId,
            invoiceGenerationRecord,
            finalOfferLetter
        } = this.state;
        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: {
                    span: 8,
                    md: { span: 4 }
                },
                wrapperCol: {
                    xs: { span: 24 },
                    sm: { span: 16 },
                    md: { span: 12 }
                }
            }
        }

        // const inputSchema2 = {
        //     fields: [
        //         {
        //             label: 'Invoice Generation dates',
        //             key: 'nextInvoiceDate',
        //             disabled: true,
        //             type: 'date',
        //             rightComp: <Button style={{ marginLeft: '3px' }} type="primary" onClick={() => {
        //                 let x = [...this.state.invoiceDates];
        //                 // if (this.state.commissionStatus === "Pending" || this.state.commissionStatus === "Inactive") {
        //                 //     notification.error({
        //                 //         message: 'Please Approve University Commission'
        //                 //     })
        //                 //     return
        //                 // }
        //                 if (x && x.length < totalInvoice) {
        //                     let date = form.getFieldValue('nextInvoiceDate')
        //                     if (date) {
        //                         let duplicateDate = _.find(x, (item) => {
        //                             return moment(item.generationDate).format('DD-MMM-YYYY') === moment(date && date._d).format('DD-MMM-YYYY')
        //                         })
        //                         if (duplicateDate) {
        //                             notification.error({
        //                                 message: 'Date already exists'
        //                             })
        //                         } else {
        //                             x.push({ generationDate: moment(date) && moment(date._d) })

        //                             this.setState({ invoiceDates: x }, () => {

        //                                 if (visaDesk && visaDesk.courseStartDate) {
        //                                     let $this = this;
        //                                     if (x.length > 0) {
        //                                         let invoiceIndex = x.length;
        //                                         $this.props.form.setFieldsValue({ nextInvoiceDate: Moment(x[invoiceIndex - 1].generationDate).add(5, 'months') });
        //                                     } else {
        //                                         $this.props.form.setFieldsValue({ nextInvoiceDate: Moment(visaDesk.courseStartDate).add(30, 'days') });
        //                                     }
        //                                 }
        //                             })
        //                         }
        //                     } else {
        //                         notification.error({
        //                             message: 'Select Date'
        //                         })
        //                     }
        //                 } else {
        //                     notification.error({
        //                         message: `Allowed only ${totalInvoice} invoice for this selected university. If you want add more please change it from Commission Claim desk.`
        //                     })
        //                 }
        //             }}>{<Icon type="plus" />}</Button>,
        //             extra: '(Vision will give you alert on these dates)'
        //         }
        //     ]
        // }
        const inputSchema2 = {
            fields: [
                {
                    label: 'Invoice Generation dates',
                    key: 'nextInvoiceDate',
                    disabled: true,
                    type: 'date',
                    rightComp: (
                        <Button
                            style={{ marginLeft: '3px' }}
                            type="primary"
                            onClick={() => {
                                let x = (this.state && this.state.invoiceDates) ? [...this.state.invoiceDates] : [];

                                // Check if addition is allowed based on totalInvoice count
                                if (x && x.length < totalInvoice) {
                                    let date = form.getFieldValue('nextInvoiceDate');

                                    if (date) {
                                        // Check for duplicate dates using traditional underscore/lodash logic
                                        let duplicateDate = _.find(x, (item) => {
                                            const itemDate = item && item.generationDate ? item.generationDate : null;
                                            const selectedDate = date && date._d ? date._d : date;

                                            return moment(itemDate).format('DD-MMM-YYYY') === moment(selectedDate).format('DD-MMM-YYYY');
                                        });

                                        if (duplicateDate) {
                                            notification.error({
                                                message: 'Date already exists'
                                            });
                                        } else {
                                            // Add valid date to the list
                                            const pushDate = date && date._d ? date._d : date;
                                            x.push({ generationDate: moment(pushDate) });

                                            this.setState({ invoiceDates: x }, () => {
                                                // Auto-calculate the next suggested invoice date (Add 5 months)
                                                if (visaDesk && visaDesk.courseStartDate) {
                                                    let $this = this;
                                                    if (x.length > 0) {
                                                        let invoiceIndex = x.length;
                                                        let lastDate = x[invoiceIndex - 1].generationDate;
                                                        $this.props.form.setFieldsValue({
                                                            nextInvoiceDate: moment(lastDate).add(5, 'months')
                                                        });
                                                    } else {
                                                        $this.props.form.setFieldsValue({
                                                            nextInvoiceDate: moment(visaDesk.courseStartDate).add(30, 'days')
                                                        });
                                                    }
                                                }
                                            });
                                        }
                                    } else {
                                        notification.error({
                                            message: 'Select Date'
                                        });
                                    }
                                } else {
                                    notification.error({
                                        message: 'Allowed only ' + totalInvoice + ' invoice for this selected university. If you want add more please change it from Commission Claim desk.'
                                    });
                                }
                            }}
                        >
                            <Icon type="plus" />
                        </Button>
                    ),
                    extra: '(Vision will give you alert on these dates)'
                }
            ]
        };

        let generatedInvoicesList = [];
        if (info && info.generatedInvoices != undefined && info.generatedInvoices && info.generatedInvoices.length > 0) {
            info.generatedInvoices.map((invoice) => {
                generatedInvoicesList[invoice.invoiceNumber] = invoice;
            })
        }
        let columns = [
            {
                title: 'Term',
                key: 'invoiceNo',
                width: 60,
                align: 'center',
                render: (item, record, key) => (
                    <Badge count={key + 1} style={{ backgroundColor: '#f0f2f5', color: '#595959', boxShadow: 'none', border: '1px solid #d9d9d9' }} />
                )
            },
            // {
            //     title: 'Inv Generation Dates',
            //     key: 'generationDate',
            //     dataIndex: 'generationDate',
            //     width: 140,
            //     render: (item, record, index) => {
            //         if (editItem && editItem[index] == true) {
            //             return (
            //                 <Input type='date' size="small" onChange={(e) => {
            //                     let editItem = this.state.editItem;
            //                     this.setState({ editItem });
            //                     invoiceDates[index].generationDate = moment(e.target.value).toDate();
            //                     this.setState({ invoiceDates });
            //                 }} value={item ? moment(item).format('YYYY-MM-DD') : ''} />
            //             )
            //         } else {
            //             return <div style={{ fontWeight: 500 }}>{item ? moment(item).format(dateFormat) : ''}</div>
            //         }
            //     }
            // },
            {
                title: 'Inv Generation Dates',
                key: 'generationDate',
                dataIndex: 'generationDate',
                width: 140,
                render: (item, record, index) => {

                    // allow edit only for admin / finance admin
                    const canEditDate =
                        activeUser &&
                        (
                            activeUser.isAdministrator ||
                            activeUser.isFiannanceAdmin
                        );

                    if (
                        canEditDate &&
                        editItem &&
                        editItem[index] == true
                    ) {

                        return (
                            <Input
                                type='date'
                                size="small"
                                onChange={(e) => {

                                    let editItem = this.state.editItem;

                                    this.setState({ editItem });

                                    invoiceDates[index].generationDate =
                                        moment(e.target.value).toDate();

                                    this.setState({ invoiceDates });

                                }}
                                value={item ? moment(item).format('YYYY-MM-DD') : ''}
                            />
                        )

                    } else {

                        return (
                            <div style={{ fontWeight: 500 }}>
                                {item ? moment(item).format(dateFormat) : ''}
                            </div>
                        )
                    }
                }
            },
            {
                title: 'Inv. No.',
                key: 'invoiceGeneratedNumber',
                width: 140,
                render: (text, record, key) => {
                    let invoiceStatusClass = '#ffcc00';
                    if (generatedInvoicesList[record.invoiceGeneratedNumber] != undefined) {
                        if (['Paid by Uni', 'Cleared'].includes(generatedInvoicesList[record.invoiceGeneratedNumber].invoiceStatus)) {
                            invoiceStatusClass = 'green';
                        } else if (['Approved by Uni'].includes(generatedInvoicesList[record.invoiceGeneratedNumber].invoiceStatus)) {
                            invoiceStatusClass = 'blue';
                        } else if (['Generated', 'Submitted to Uni'].includes(generatedInvoicesList[record.invoiceGeneratedNumber].invoiceStatus)) {
                            invoiceStatusClass = '#ffcc00';
                        }
                    } else if (record.uploaded === true && record.cpUploadInvoice.length > 0) {
                        if (['Generated', 'Submitted to Uni'].includes(record.invoiceStatus)) {
                            invoiceStatusClass = '#ffcc00';
                        } else if (['Approved by Uni'].includes(record.invoiceStatus)) {
                            invoiceStatusClass = 'blue';
                        } else if (['Paid by Uni', 'Cleared'].includes(record.invoiceStatus)) {
                            invoiceStatusClass = 'green';
                        }
                    }
                    return (
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                            <Tooltip title="View Invoice Details">
                                {record.invoiceGeneratedNumber && record.uploaded !== true ? (
                                    <Button size="small" style={{ backgroundColor: invoiceStatusClass, color: 'white', border: 'none', fontWeight: 'bold', width: 'fit-content', padding: '0 8px' }} onClick={() => { this.loadInvoiceDetail(record.invoiceGeneratedNumber) }}>
                                        {record.invoiceGeneratedNumber}
                                    </Button>
                                ) : record.uploaded == true && record.cpUploadInvoice.length > 0 ? (
                                    <Button size="small" style={{ backgroundColor: invoiceStatusClass, color: 'white', border: 'none', fontWeight: 'bold', width: 'fit-content', padding: '0 8px' }} target='_blank' href={MEDIA_URL + record.cpUploadInvoice[0].url}>
                                        {record.cpInvoiceNumber ? record.cpInvoiceNumber : record.invoiceGeneratedNumber}
                                    </Button>
                                ) : <span style={{ color: '#bfbfbf', fontStyle: 'italic' }}>To Be Issued</span>}
                            </Tooltip>
                        </div>
                    )
                }
            },
            {
                title: 'Comm. Amount',
                key: 'commReceived',
                width: 150,
                render: (text, invoiceDate) => {
                    let commissionTotal = "NA";
                    let currency = '';
                    let generatedInvoice = generatedInvoicesList[invoiceDate.invoiceGeneratedNumber];
                    if (generatedInvoice && generatedInvoice.invoices) {
                        let foundInvoice = generatedInvoice.invoices.find((invoice) =>
                            invoice.invoiceGeneratedRecordId && invoiceDate && invoiceDate._id &&
                            this.getIdString(invoice.invoiceGeneratedRecordId) === this.getIdString(invoiceDate._id)
                        );
                        if (foundInvoice && foundInvoice.commissionTotal !== undefined && foundInvoice.commissionTotal !== null && !isNaN(foundInvoice.commissionTotal)) {
                            commissionTotal = Number(foundInvoice.commissionTotal).toFixed(2);
                        }
                    } else {
                        if (invoiceDate && invoiceDate.commReceived !== undefined && invoiceDate.commReceived !== null && !isNaN(invoiceDate.commReceived)) {
                            commissionTotal = Number(invoiceDate.commReceived).toFixed(2);
                        }
                    }
                    if (visaDesk && visaDesk.selectedCourse && visaDesk.selectedCourse.currency) {
                        currency = visaDesk.selectedCourse.currency;
                    }
                    return <div style={{ fontWeight: 'bold', textAlign: 'right' }}>{commissionTotal} <small style={{ color: '#8c8c8c' }}>{currency ? ' (' + currency + ')' : ''}</small></div>;
                }
            },
            {
                title: 'Conversion',
                key: 'conversionRate',
                width: 130,
                render: (text, invoiceDate) => {
                    let conversionRate = null;
                    let currency = companyDetail && companyDetail.companyCurrency ? companyDetail.companyCurrency : null;
                    let generatedInvoice = generatedInvoicesList[invoiceDate.invoiceGeneratedNumber];
                    if (generatedInvoice && generatedInvoice.invoices) {
                        let foundInvoice = generatedInvoice.invoices.find((invoice) =>
                            invoice.invoiceGeneratedRecordId && invoiceDate && invoiceDate._id &&
                            this.getIdString(invoice.invoiceGeneratedRecordId) === this.getIdString(invoiceDate._id)
                        );
                        if (foundInvoice && foundInvoice.conversionRate) conversionRate = foundInvoice.conversionRate;
                    } else if (invoiceDate && invoiceDate.conversionRate) {
                        conversionRate = invoiceDate.conversionRate;
                    }
                    if (!conversionRate) return null;
                    return <div style={{ fontSize: '12px', color: '#595959' }}>{conversionRate} <small>{currency ? ` (${currency})` : ''}</small></div>;
                }
            },
            {
                title: 'Converted Amt',
                key: 'convertedAmount',
                width: 130,
                render: (text, invoiceDate) => {
                    let amount = null;
                    let currency = companyDetail && companyDetail.companyCurrency ? companyDetail.companyCurrency : null;
                    let generatedInvoice = generatedInvoicesList[invoiceDate.invoiceGeneratedNumber];
                    if (generatedInvoice && generatedInvoice.invoices) {
                        let foundInvoice = generatedInvoice.invoices.find((invoice) =>
                            invoice.invoiceGeneratedRecordId && invoiceDate && invoiceDate._id &&
                            this.getIdString(invoice.invoiceGeneratedRecordId) === this.getIdString(invoiceDate._id)
                        );
                        if (foundInvoice && typeof foundInvoice.grossPaymentReceived === 'number' && foundInvoice.grossPaymentReceived > 0) {
                            amount = foundInvoice.grossPaymentReceived;
                        } else if (foundInvoice && typeof foundInvoice.commissionTotalConverted === 'number') {
                            amount = foundInvoice.commissionTotalConverted && foundInvoice.commissionTotalConverted > 0 ? foundInvoice.commissionTotalConverted : foundInvoice.commissionTotal && foundInvoice.commissionTotal > 0 && foundInvoice.conversionRate && foundInvoice.conversionRate > 0 ? parseFloat(foundInvoice.commissionTotal) * parseFloat(foundInvoice.conversionRate).toFixed() : 0;
                        }
                    } else if (invoiceDate && typeof invoiceDate.totalAfterConversion === 'number') {
                        amount = invoiceDate.totalAfterConversion;
                    }
                    if (!amount || amount <= 0) return null;
                    return <div style={{ fontWeight: 'bold', color: '#52c41a', textAlign: 'right' }}>{amount.toFixed(2)} <small>{currency ? ` (${currency})` : ''}</small></div>;
                }
            },
            {
                title: 'Receiving Bank',
                key: 'cpPaymentReceivingBank',
                render: function (_, invoiceDate) {
                    let bankId;
                    let generatedInvoice = generatedInvoicesList[invoiceDate.invoiceGeneratedNumber];
                    if (generatedInvoice) {
                        if (!generatedInvoice.companyBankId) return null;
                        bankId = generatedInvoice.companyBankId;
                    } else {
                        if (!invoiceDate || !invoiceDate.cpPaymentReceivingBank) return null;
                        bankId = invoiceDate.cpPaymentReceivingBank;
                    }
                    let clearanceStatus = generatedInvoice && generatedInvoice.invoiceStatus ? generatedInvoice.invoiceStatus : invoiceDate.invoiceStatus;
                    let normalizedStatus = clearanceStatus ? clearanceStatus.toLowerCase().trim() : '';
                    var bankDetails = this.state.bankDetails || [];
                    let receivingBank = null;
                    for (var i = 0; i < bankDetails.length; i++) {
                        if (String(bankDetails[i]._id) === String(bankId)) {
                            receivingBank = bankDetails[i];
                            break;
                        }
                    }
                    if (!receivingBank || !receivingBank.display || (normalizedStatus !== 'paid by uni' && normalizedStatus !== 'cleared')) return null;
                    return <Tag color="blue" style={{ margin: 0 }}>{receivingBank.display}</Tag>;
                }.bind(this)
            },
            {
                title: 'Inv Status',
                key: 'invoiceStatus',
                dataIndex: 'invoiceStatus',
                width: 180,
                render: (item, record, index) => {
                    if (editItem && editItem[index] === true && ((record && Array.isArray(record.cpUploadInvoice) && record.cpUploadInvoice.length > 0) || (record && Array.isArray(record.apUploadInvoice) && record.apUploadInvoice.length > 0))) {
                        return (
                            <Select size="small" style={{ width: '100%' }} onChange={(val) => {
                                let editItem = this.state.editItem;
                                this.setState({ editItem });
                                invoiceDates[index].invoiceStatus = val;
                                this.setState({ invoiceDates });
                            }} value={item}>
                                <Option value="Generated">Generated</Option>
                                <Option value="Submitted to Uni">Submitted to Uni</Option>
                                <Option value="Approved by Uni">Approved by Uni</Option>
                                <Option value="Paid by Uni">Paid by Uni</Option>
                                <Option value="Cleared">Cleared</Option>
                            </Select>
                        )
                    }
                    let status = item;
                    let color = '#faad14';
                    const genInv = generatedInvoicesList[record.invoiceGeneratedNumber];
                    if (genInv && genInv.invoiceStatus) status = genInv.invoiceStatus;

                    if (['Paid by Uni', 'Cleared'].includes(status)) color = 'green';
                    else if (['Approved by Uni'].includes(status)) color = 'blue';

                    if (!status) return 'NA';
                    return <Tag color={color} style={{ width: '100%', textAlign: 'center', margin: 0 }}>{status === "Paid by Uni" ? "Commission Received" : status}</Tag>;
                }
            },
            // {
            //     title: 'Clearance',
            //     key: 'invoiceReceivedDate',
            //     width: 120,
            //     render: (item, record, index) => {
            //         if (editItem && editItem[index] == true && ((record && record.cpUploadInvoice && record.cpUploadInvoice[0]) || (record && record.apUploadInvoice && record.apUploadInvoice[0]))) {
            //             return <Input type='date' size="small" onChange={(e) => {
            //                 invoiceDates[index].invoiceReceivedDate = moment(e.target.value).toDate();
            //                 this.setState({ invoiceDates });
            //             }} value={item ? moment(item).format('YYYY-MM-DD') : ''} />
            //         }
            //         let finalDate;
            //         let genInv = generatedInvoicesList[record.invoiceGeneratedNumber];
            //         if (genInv) {
            //             finalDate = (genInv && genInv.invoiceReceivingDate) ? genInv.invoiceReceivingDate : null
            //         } else if (record.uploaded) {
            //             finalDate = (record && record.invoiceReceivedDate) ? record.invoiceReceivedDate : null
            //         }
            //         // let finalDate = (genInv && genInv.invoiceReceivingDate) ? genInv.invoiceReceivingDate : item;
            //         return finalDate ? moment(finalDate).format(dateFormat) : 'NA';
            //     }
            // },
            {
                title: 'Clearance',
                key: 'invoiceReceivedDate',
                width: 120,
                render: (item, record, index) => {

                    const invoiceDates = this.state.invoiceDates || [];

                    const isEditable =
                        editItem &&
                        editItem[index] === true &&
                        (
                            (record && record.cpUploadInvoice && record.cpUploadInvoice[0]) ||
                            (record && record.apUploadInvoice && record.apUploadInvoice[0])
                        );

                    let defaultDate = moment(record.invoiceReceivedDate).format('YYYY-MM-DD');
                    if (isEditable) {
                        return (
                            <Input
                                type="date"
                                size="small"
                                value={
                                    defaultDate
                                }
                                onChange={(e) => {
                                    const updated = [...invoiceDates];

                                    updated[index] = {
                                        ...(updated[index] || {}),
                                        invoiceReceivedDate: e.target.value
                                    };

                                    this.setState({ invoiceDates: updated });
                                }}
                            />
                        );
                    }

                    let finalDate = null;
                    let genInv = generatedInvoicesList[record.invoiceGeneratedNumber];


                    if (genInv && genInv.invoiceReceivingDate) {
                        finalDate = genInv.invoiceReceivingDate;
                    } else if (record && record.uploaded && record.invoiceReceivedDate) {
                        finalDate = record.invoiceReceivedDate;
                    }

                    return finalDate ? moment(finalDate).format(dateFormat) : 'NA';
                }
            },
            {
                title: 'Upload Docs',
                key: 'uploads',
                width: 180,
                render: (text, record) => (
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                        {/* CP Invoice Info Preservation */}
                        {(record.cpInvoiceNumber || record.invoiceGeneratedNumber) && record.cpUploadInvoice && record.cpUploadInvoice.length > 0 &&
                            <div style={{ fontSize: '11px' }}><b>No:</b> {record.cpInvoiceNumber ? record.cpInvoiceNumber : record.invoiceGeneratedNumber}</div>}
                        {record.cpReceiptUpload && record.cpReceiptUpload[0] && record.cpReceiptUpload[0].url &&
                            <div style={{ fontSize: '11px' }}><b>Receipt:</b> <a target='_blank' href={MEDIA_URL + record.cpReceiptUpload[0].url}>View</a></div>}

                        <Button size="small" icon="upload" type={record.cpInvoiceNumber ? "primary" : "dashed"}
                            style={{ width: '110px', fontSize: '11px', color: record.cpInvoiceNumber ? '#fff' : '#1890ff', borderColor: record.cpInvoiceNumber ? '#1890ff' : '#91d5ff' }}
                            onClick={() => {
                                if (record.invoiceGeneratedNumber && generatedInvoicesList && generatedInvoicesList[record.invoiceGeneratedNumber] && !record.cpInvoiceNumber) {
                                    notification.error({
                                        message: "Action Denied",
                                        description: "A system-generated invoice already exists for this term. Please delete it first before manually uploading a document."
                                    });
                                    return;
                                }
                                this.setState({ invoiceGeneratedId: record._id, showGeneratedCPInvoiceData: true, uploaded: true }, () => {
                                    setTimeout(() => { this.props.form.setFieldsValue({ cpUploadInvoice: record.cpUploadInvoice, commReceived: record.commReceived, conversionRate: record.conversionRate, totalAfterConversion: record.totalAfterConversion, cpPaymentReceivingBank: record.cpPaymentReceivingBank, cpInvoiceNumber: record.cpInvoiceNumber, cpReceiptUpload: record.cpReceiptUpload ? record.cpReceiptUpload : [] }); }, 1000)
                                })
                            }}>{record.cpInvoiceNumber ? 'Update CP' : 'Upload CP'}</Button>

                        {/* Agent Invoice Info Preservation */}
                        {record.apUploadInvoice && record.apUploadInvoice[0] && record.apUploadInvoice[0].url &&
                            <div style={{ fontSize: '11px' }}><a target='_blank' href={MEDIA_URL + record.apUploadInvoice[0].url}>View Agent Inv</a></div>}
                        {record.apInvoiceNumber && <div style={{ fontSize: '11px' }}><b>No:</b> {record.apInvoiceNumber}</div>}
                        {record.apReceiptUpload && record.apReceiptUpload[0] && record.apReceiptUpload[0].url &&
                            <div style={{ fontSize: '11px' }}><b>Advice:</b> <a target='_blank' href={MEDIA_URL + record.apReceiptUpload[0].url}>View</a></div>}

                        <Button size="small" icon="upload" type={record.apInvoiceNumber ? "primary" : "dashed"}
                            style={{ width: '110px', fontSize: '11px', color: record.apInvoiceNumber ? '#fff' : '#1890ff', borderColor: record.apInvoiceNumber ? '#1890ff' : '#91d5ff' }}
                            onClick={() => {
                                this.setState({ invoiceGeneratedId: record._id, showGeneratedInvoiceData: true, uploaded: true }, () => {
                                    setTimeout(() => { this.props.form.setFieldsValue({ apUploadInvoice: record.apUploadInvoice, apInvoiceNumber: record.apInvoiceNumber, apReceiptUpload: record.apReceiptUpload ? record.apReceiptUpload : [] }); }, 1000)
                                })
                            }}>{record.apInvoiceNumber ? 'Update Agent' : 'Upload Agent'}</Button>
                    </div>
                )
            },
            {
                title: 'Actions',
                key: 'operation',
                width: 140,
                align: 'right',
                render: (val, record, index) => (
                    <div style={{ display: 'flex', gap: '5px', justifyContent: 'flex-end' }}>
                        <Tooltip title="edit">
                            <Button size='small' icon='edit' type="primary" onClick={() => {
                                let editItem = this.state.editItem;
                                editItem[index] = true;
                                this.setState({ editItem });
                            }} />
                        </Tooltip>

                        <RightsWrapper myRight={"ClaimDesk.delete"}>
                            <Tooltip title="Reset/Remove Invoice">
                                <Popconfirm title="Reset/Remove Invoice details?" onConfirm={() => this.resetInvoiceTerm(record, info)}>
                                    <Button size='small' icon='rollback' type="danger" />
                                </Popconfirm>
                            </Tooltip>
                        </RightsWrapper>
                        <RightsWrapper myRight={"ClaimDesk.delete"}>
                            <Popconfirm title="Delete?" onConfirm={() => { invoiceDates.splice(index, 1); this.setState({ invoiceDates }); }}>
                                <Button size='small' icon='delete' type="danger" />
                            </Popconfirm>
                        </RightsWrapper>
                        <Tooltip title="Withdraw"><Button size='small' icon='close' type="danger" onClick={() => this.setState({ recordId: { _id: info._id }, invoiceGenerationRecord: record, showWithdrawForm: true })} /></Tooltip>
                    </div>
                )
            }
        ];
        const columnss = [
            {
                title: 'Term No',
                key: 'invoiceNo',
                width: 80,
                render: (item, record, key) => {
                    return key + 1
                }
            },
            {
                title: 'Inv Generation Dates',
                key: 'generationDate',
                dataIndex: 'generationDate',
                render: (item, record, index) => {
                    if (editItem && editItem[index] == true) {
                        return (<div>
                            <Input type='date' onChange={(e) => {
                                let editItem = this.state.editItem;
                                // editItem[index] = false;
                                this.setState({ editItem });
                                invoiceDates[index].generationDate = moment(e.target.value).toDate();
                                this.setState({ invoiceDates });
                            }} value={item ? moment(item).format('YYYY-MM-DD') : ''} />
                        </div>)
                    } else {
                        return (<div>{item ? moment(item).format(dateFormat) : ''}</div>)
                    }
                }
            },
            {
                title: 'Inv. No.',
                key: 'invoiceGeneratedNumber',
                width: 120,
                render: (text, record, key) => {
                    let invoiceStatusClass = '#ffcc00';
                    if (generatedInvoicesList[record.invoiceGeneratedNumber] != undefined) {
                        if (['Paid by Uni', 'Cleared'].includes(generatedInvoicesList[record.invoiceGeneratedNumber].invoiceStatus)) {
                            invoiceStatusClass = 'green';
                        } else if (['Approved by Uni'].includes(generatedInvoicesList[record.invoiceGeneratedNumber].invoiceStatus)) {
                            invoiceStatusClass = 'blue';
                        } else if (['Generated', 'Submitted to Uni'].includes(generatedInvoicesList[record.invoiceGeneratedNumber].invoiceStatus)) {
                            invoiceStatusClass = '#ffcc00';
                        }
                    } else if (record.uploaded === true && record.cpUploadInvoice.length > 0) {
                        if (['Generated', 'Submitted to Uni'].includes(record.invoiceStatus)) {
                            invoiceStatusClass = '#ffcc00';
                        } else if (['Approved by Uni'].includes(record.invoiceStatus)) {
                            invoiceStatusClass = 'blue';
                        } else if (['Paid by Uni', 'Cleared'].includes(record.invoiceStatus)) {
                            invoiceStatusClass = 'green';
                        }
                    }
                    return (
                        <React.Fragment>
                            <div>
                                <Tooltip title="View Invoice Details">
                                    {
                                        record.invoiceGeneratedNumber && record.uploaded !== true ?
                                            <Button style={{ backgroundColor: invoiceStatusClass, color: 'white' }} onClick={() => { this.loadInvoiceDetail(record.invoiceGeneratedNumber) }}>
                                                {record.invoiceGeneratedNumber}
                                            </Button>

                                            : record.uploaded == true && record.cpUploadInvoice.length > 0 ? <Button style={{ backgroundColor: invoiceStatusClass, color: 'white' }} target='_blank' href={MEDIA_URL + '' + record.cpUploadInvoice[0].url}>{record.cpInvoiceNumber ? record.cpInvoiceNumber : record.invoiceGeneratedNumber}</Button> : 'To Be Issued'
                                    }
                                </Tooltip>
                            </div>
                        </React.Fragment>
                    )
                }
            },
            {
                title: 'Commisssion Amount',
                key: 'commReceived',
                render: (text, invoiceDate) => {
                    let commissionTotal = "NA";
                    let currency = '';
                    let generatedInvoice = generatedInvoicesList[invoiceDate.invoiceGeneratedNumber];

                    if (generatedInvoice && generatedInvoice.invoices) {

                        let foundInvoice = generatedInvoice.invoices.find((invoice) => {
                            return (
                                invoice.invoiceGeneratedRecordId &&
                                invoiceDate &&
                                invoiceDate._id &&
                                this.getIdString(invoice.invoiceGeneratedRecordId) ===
                                this.getIdString(invoiceDate._id)
                            );
                        });

                        if (
                            foundInvoice &&
                            foundInvoice.commissionTotal !== undefined &&
                            foundInvoice.commissionTotal !== null &&
                            !isNaN(foundInvoice.commissionTotal)
                        ) {
                            commissionTotal = Number(foundInvoice.commissionTotal).toFixed(2);
                        }

                    } else {

                        if (
                            invoiceDate &&
                            invoiceDate.commReceived !== undefined &&
                            invoiceDate.commReceived !== null &&
                            !isNaN(invoiceDate.commReceived)
                        ) {
                            commissionTotal = Number(invoiceDate.commReceived).toFixed(2);
                        }
                    }

                    if (
                        visaDesk &&
                        visaDesk.selectedCourse &&
                        visaDesk.selectedCourse.currency
                    ) {
                        currency = visaDesk.selectedCourse.currency;
                    }

                    return (
                        <div>
                            {commissionTotal}
                            {currency ? ' (' + currency + ')' : ''}
                        </div>
                    );
                }

            },
            // {
            //     title: 'Commission Amount',
            //     key: 'commReceived',
            //     render: function (_, record) {
            //         if (!record || !record.commReceived) return null;

            //         var currency = '';
            //         if (
            //             record.visaDesk &&
            //             record.visaDesk.selectedCourse &&
            //             record.visaDesk.selectedCourse.currency
            //         ) {
            //             currency = record.visaDesk.selectedCourse.currency;
            //         }

            //         return (
            //             <div>
            //                 <strong>Commission:</strong> {record.commReceived}
            //                 {currency ? ' (' + currency + ')' : ''}
            //             </div>
            //         );
            //     }
            // },
            {
                title: 'Conversion Rate',
                key: 'conversionRate',
                render: (text, invoiceDate) => {
                    let conversionRate = null;
                    let currency =
                        companyDetail && companyDetail.companyCurrency
                            ? companyDetail.companyCurrency
                            : null;

                    let generatedInvoice =
                        generatedInvoicesList[invoiceDate.invoiceGeneratedNumber];

                    if (generatedInvoice && generatedInvoice.invoices) {
                        let foundInvoice = generatedInvoice.invoices.find((invoice) => {
                            return (
                                invoice.invoiceGeneratedRecordId &&
                                invoiceDate &&
                                invoiceDate._id &&
                                this.getIdString(invoice.invoiceGeneratedRecordId) ===
                                this.getIdString(invoiceDate._id)
                            );
                        });

                        if (foundInvoice && foundInvoice.conversionRate) {
                            conversionRate = foundInvoice.conversionRate;
                        }
                    } else if (invoiceDate && invoiceDate.conversionRate) {
                        conversionRate = invoiceDate.conversionRate;
                    }

                    // ⛔ hide everything if value missing
                    if (!conversionRate) return null;

                    return (
                        <div>
                            {conversionRate}
                            {currency ? ` (${currency})` : ''}
                        </div>
                    );
                }
            },
            {
                title: 'Converted Amount',
                key: 'convertedAmount',
                render: (text, invoiceDate) => {
                    let amount = null;
                    let currency =
                        companyDetail && companyDetail.companyCurrency
                            ? companyDetail.companyCurrency
                            : null;

                    let generatedInvoice =
                        generatedInvoicesList[invoiceDate.invoiceGeneratedNumber];

                    if (generatedInvoice && generatedInvoice.invoices) {
                        let foundInvoice = generatedInvoice.invoices.find((invoice) => {
                            return (
                                invoice.invoiceGeneratedRecordId &&
                                invoiceDate &&
                                invoiceDate._id &&
                                this.getIdString(invoice.invoiceGeneratedRecordId) ===
                                this.getIdString(invoiceDate._id)
                            );
                        });

                        if (
                            foundInvoice &&
                            typeof foundInvoice.grossPaymentReceived === 'number' &&
                            foundInvoice.grossPaymentReceived > 0
                        ) {
                            amount = foundInvoice.grossPaymentReceived;
                        } else if (
                            foundInvoice &&
                            typeof foundInvoice.commissionTotalConverted === 'number'
                        ) {
                            amount = foundInvoice.commissionTotalConverted && foundInvoice.commissionTotalConverted > 0 ? foundInvoice.commissionTotalConverted : foundInvoice.commissionTotal && foundInvoice.commissionTotal > 0 && foundInvoice.conversionRate && foundInvoice.conversionRate > 0 ? parseFloat(foundInvoice.commissionTotal) * parseFloat(foundInvoice.conversionRate).toFixed() : 0;
                        }


                    } else if (
                        invoiceDate &&
                        typeof invoiceDate.totalAfterConversion === 'number'
                    ) {
                        amount = invoiceDate.totalAfterConversion;
                    }

                    // ⛔ DO NOT SHOW if amount is null, undefined, 0 or less
                    if (!amount || amount <= 0) return null;

                    return (
                        <div>
                            {amount.toFixed(2)}
                            {currency ? ` (${currency})` : ''}
                        </div>
                    );
                }
            },
            // {
            //     title: 'Converted Amount',
            //     key: 'totalAfterConversion',
            //     render: function (_, record) {
            //         if (!record || !record.totalAfterConversion) return null;

            //         return (
            //             <div>
            //                 <strong>Converted Commission:</strong> {record.totalAfterConversion}
            //             </div>
            //         );
            //     }
            // },
            {
                title: 'Receiving Bank',
                key: 'cpPaymentReceivingBank',
                render: function (_, invoiceDate) {

                    let bankId;
                    let generatedInvoice = generatedInvoicesList[invoiceDate.invoiceGeneratedNumber];

                    if (generatedInvoice) {
                        if (!generatedInvoice.companyBankId) return null;
                        bankId = generatedInvoice.companyBankId;
                    } else {
                        if (!invoiceDate || !invoiceDate.cpPaymentReceivingBank) return null;
                        bankId = invoiceDate.cpPaymentReceivingBank;
                    }

                    let clearanceStatus = generatedInvoice && generatedInvoice.invoiceStatus
                        ? generatedInvoice.invoiceStatus
                        : invoiceDate.invoiceStatus;

                    let normalizedStatus = clearanceStatus
                        ? clearanceStatus.toLowerCase().trim()
                        : '';

                    var bankDetails = this.state.bankDetails || [];
                    let receivingBank = null;

                    for (var i = 0; i < bankDetails.length; i++) {
                        if (String(bankDetails[i]._id) === String(bankId)) {
                            receivingBank = bankDetails[i];
                            break;
                        }
                    }

                    // ✅ FIXED STATUS CHECK
                    if (
                        !receivingBank ||
                        !receivingBank.display ||
                        (normalizedStatus !== 'paid by uni' && normalizedStatus !== 'cleared')
                    ) {
                        return null;
                    }

                    return (
                        <div>
                            {receivingBank.display}
                        </div>
                    );
                }.bind(this)
            },
            // {
            //     title: 'Commission Amount',
            //     key: 'commReceived',
            //     dataIndex: 'commReceived',
            //     render: (item, record, index) => {
            //         if (editItem && editItem[index] == true && (record && record.cpUploadInvoice && record.cpUploadInvoice[0])) {
            //             return (<div>
            //                 <Input type='number' onChange={(e) => {
            //                     let editItem = this.state.editItem;
            //                     // editItem[index] = false;
            //                     this.setState({ editItem });
            //                     invoiceDates[index].commReceived = e.target.value
            //                     this.setState({ invoiceDates });
            //                 }} value={item ? item : ''} />
            //             </div>)
            //         } else {
            //             if (record.uploaded === false && record.invoiceGeneratedNumber) {

            //                 let generatedInvoice = generatedInvoicesList[record.invoiceGeneratedNumber];
            //                 let foundGeneratedInvoice = generatedInvoice && generatedInvoice.invoices && generatedInvoice.invoices.find(obj => {
            //                     return obj.invoiceGeneratedRecordId === record._id;
            //                 });
            //                 return (
            //                     <div>{foundGeneratedInvoice && foundGeneratedInvoice.commissionTotal} - {foundGeneratedInvoice && foundGeneratedInvoice.currency}</div>
            //                 )
            //             } else if (item && item != null) {
            //                 return (<div>{item ? `${item}(${visaDesk.selectedCourse.currency})` : ''}</div>)
            //             } else {
            //                 return 'NA';
            //             }
            //         }
            //     }
            // },
            {
                title: 'Inv Status',
                key: 'invoiceStatus',
                dataIndex: 'invoiceStatus',
                width: 180,
                render: (item, record, index) => {
                    if (
                        editItem && editItem[index] === true &&
                        (
                            (record && Array.isArray(record.cpUploadInvoice) && record.cpUploadInvoice.length > 0) ||
                            (record && Array.isArray(record.apUploadInvoice) && record.apUploadInvoice.length > 0)
                        )
                    ) {
                        return (<div>
                            <Select onChange={(invoiceStatus) => {
                                let editItem = this.state.editItem;
                                this.setState({ editItem });
                                invoiceDates[index].invoiceStatus = invoiceStatus;
                                this.setState({ invoiceDates });
                            }} value={item}>
                                <Option value={"Generated"}>Generated</Option>
                                <Option value={"Submitted to Uni"}>Submitted to Uni</Option>
                                <Option value={"Approved by Uni"}>Approved by Uni</Option>
                                <Option value={"Paid by Uni"}>Paid by Uni</Option>
                                <Option value={"Cleared"}>Cleared</Option>
                            </Select>

                        </div>)
                    } else {
                        if (generatedInvoicesList[record.invoiceGeneratedNumber] != undefined && generatedInvoicesList[record.invoiceGeneratedNumber].invoiceGeneratedDate) {
                            let invoiceStatusClass = '#ffcc00';
                            if (generatedInvoicesList[record.invoiceGeneratedNumber] != undefined) {
                                if (['Paid by Uni', 'Cleared'].includes(generatedInvoicesList[record.invoiceGeneratedNumber].invoiceStatus)) {
                                    invoiceStatusClass = 'green';
                                } else if (['Approved by Uni'].includes(generatedInvoicesList[record.invoiceGeneratedNumber].invoiceStatus)) {
                                    invoiceStatusClass = 'blue';
                                } else if (['Generated', 'Submitted to Uni'].includes(generatedInvoicesList[record.invoiceGeneratedNumber].invoiceStatus)) {
                                    invoiceStatusClass = '#ffcc00';
                                }
                            }
                            if (generatedInvoicesList[record.invoiceGeneratedNumber] != undefined && generatedInvoicesList[record.invoiceGeneratedNumber].invoiceStatus) {
                                return (<div style={{ backgroundColor: invoiceStatusClass, color: 'white', padding: '10px', borderRadius: '10px', textAlign: 'center' }}>{generatedInvoicesList[record.invoiceGeneratedNumber].invoiceStatus}</div>)
                            } else {
                                return 'NA';
                            }
                        } else if (item && item != null) {
                            let invoiceStatusClass = '#ffcc00';
                            if (['Paid by Uni', 'Cleared'].includes(item)) {
                                invoiceStatusClass = 'green';
                            } else if (['Approved by Uni'].includes(item)) {
                                invoiceStatusClass = 'blue';
                            } else if (['Generated', 'Submitted to Uni'].includes(item)) {
                                invoiceStatusClass = '#ffcc00';
                            }
                            if (item) {
                                return (<div style={{ backgroundColor: invoiceStatusClass, color: 'white', padding: '10px', borderRadius: '10px', textAlign: 'center' }}>{item && item === "Paid by Uni" ? "Commission Received" : item}</div>)
                            }
                        } else {
                            return 'NA';
                        }
                    }
                }
                // render: (item, record) => {
                //     let invoiceStatusClass = '#ffcc00';
                //     if (generatedInvoicesList[record.invoiceGeneratedNumber] != undefined) {
                //         if (['Paid by Uni', 'Cleared'].includes(generatedInvoicesList[record.invoiceGeneratedNumber].invoiceStatus)) {
                //             invoiceStatusClass = 'green';
                //         } else if (['Approved by Uni'].includes(generatedInvoicesList[record.invoiceGeneratedNumber].invoiceStatus)) {
                //             invoiceStatusClass = 'blue';
                //         } else if (['Generated', 'Submitted to Uni'].includes(generatedInvoicesList[record.invoiceGeneratedNumber].invoiceStatus)) {
                //             invoiceStatusClass = '#ffcc00';
                //         }
                //     }
                //     if (generatedInvoicesList[record.invoiceGeneratedNumber] != undefined && generatedInvoicesList[record.invoiceGeneratedNumber].invoiceStatus) {
                //         return (<div style={{ backgroundColor: invoiceStatusClass, color: 'white', padding: '10px', borderRadius: '10px', textAlign: 'center' }}>{generatedInvoicesList[record.invoiceGeneratedNumber].invoiceStatus}</div>)
                //     } else {
                //         return 'NA';
                //     }
                // }
            },
            {
                title: 'Last Updated On',
                key: 'invoiceAddedDate',
                dataIndex: 'invoiceAddedDate',
                render: (item, record, index) => {
                    if (
                        editItem && editItem[index] === true &&
                        (
                            (record && Array.isArray(record.cpUploadInvoice) && record.cpUploadInvoice.length > 0) ||
                            (record && Array.isArray(record.apUploadInvoice) && record.apUploadInvoice.length > 0)
                        )
                    ) {
                        return (<div>
                            <Input type='date' onChange={(e) => {
                                let editItem = this.state.editItem;
                                // editItem[index] = false;
                                this.setState({ editItem });
                                invoiceDates[index].invoiceAddedDate = moment(e.target.value).toDate();
                                this.setState({ invoiceDates });
                            }} value={item ? moment(item).format('YYYY-MM-DD') : ''} />
                        </div>)
                    } else {
                        if (generatedInvoicesList[record.invoiceGeneratedNumber] != undefined && generatedInvoicesList[record.invoiceGeneratedNumber].invoiceGeneratedDate) {
                            return (<div>{moment(generatedInvoicesList[record.invoiceGeneratedNumber].invoiceGeneratedDate).format(dateFormat)}</div>)
                        } else if (item && item != null) {
                            return (<div>{item ? moment(item).format(dateFormat) : ''}</div>)
                        } else {
                            return 'NA';
                        }
                    }
                }

                // render: (item, record) => {
                //     if (generatedInvoicesList[record.invoiceGeneratedNumber] != undefined && generatedInvoicesList[record.invoiceGeneratedNumber].invoiceReceivingDate) {
                //         return (<div>{moment(generatedInvoicesList[record.invoiceGeneratedNumber].invoiceReceivingDate).format(dateFormat)}</div>)
                //     } else {
                //         return 'NA';
                //     }
                // }
            },
            // {
            //     title:'Invoice Added Date',
            //     key:'invoiceAddedDate',
            //     dataIndex:'addedDate',
            //     render:(item,record, index) =>{
            //         if(editItem && editItem[index] == true) {
            //             return (<div>
            //                 <Input type='date' onChange={(e) => {
            //                     let editItem = this.state.editItem;
            //                     // editItem[index] = false;
            //                     this.setState({ editItem });
            //                     invoiceDates[index].invoiceAddedDate = moment(e.target.value).toDate();
            //                     this.setState({ invoiceDates });
            //                 }} value={item ? moment(item).format('YYYY-MM-DD') : ''} />
            //             </div>)
            //         }else {
            //             if (generatedInvoicesList[record.invoiceGeneratedNumber] != undefined && generatedInvoicesList[record.invoiceGeneratedNumber].invoiceGeneratedDate) {
            //                 return (<div>{moment(generatedInvoicesList[record.invoiceGeneratedNumber].invoiceGeneratedDate).format(dateFormat)}</div>)
            //             }else if(item && item !=null) {
            //                 return (<div>{item ? moment(item).format(dateFormat) : ''}</div>)
            //             } else {
            //                 return 'NA';
            //             }
            //         }
            //     }
            // },
            // {
            //     title: 'Invoice Added Date',
            //     key: 'addedDate',
            //     dataIndex: 'addedDate',
            //     render: (item, record) => {
            //         if (generatedInvoicesList[record.invoiceGeneratedNumber] != undefined && generatedInvoicesList[record.invoiceGeneratedNumber].invoiceGeneratedDate) {
            //             return (<div>{moment(generatedInvoicesList[record.invoiceGeneratedNumber].invoiceGeneratedDate).format(dateFormat)}</div>)
            //         } else {
            //             return 'NA';
            //         }
            //     }
            // },

            {
                title: 'Inv Clearance Date',
                key: 'invoiceReceivedDate',
                dataIndex: 'invoiceReceivedDate',
                render: (item, record, index) => {
                    if (editItem && editItem[index] == true && (record && record.cpUploadInvoice && record.cpUploadInvoice[0] || record && record.apUploadInvoice && record.apUploadInvoice[0])) {
                        return (<div>
                            <Input type='date' onChange={(e) => {
                                let editItem = this.state.editItem;
                                // editItem[index] = false;
                                this.setState({ editItem });
                                invoiceDates[index].invoiceReceivedDate = moment(e.target.value).toDate();
                                this.setState({ invoiceDates });
                            }} value={item ? moment(item).format('YYYY-MM-DD') : ''} />
                        </div>)
                    } else {
                        if (generatedInvoicesList[record.invoiceGeneratedNumber] != undefined && generatedInvoicesList[record.invoiceGeneratedNumber].invoiceReceivingDate) {
                            return (<div>{moment(generatedInvoicesList[record.invoiceGeneratedNumber].invoiceReceivingDate).format(dateFormat)}</div>)
                        } else if (item && item != null) {
                            return (<div>{item ? moment(item).format(dateFormat) : ''}</div>)
                        } else {
                            return 'NA';
                        }
                    }
                },

                // render: (item, record) => {
                //     if (generatedInvoicesList[record.invoiceGeneratedNumber] != undefined && generatedInvoicesList[record.invoiceGeneratedNumber].invoiceReceivingDate) {
                //         return (<div>{moment(generatedInvoicesList[record.invoiceGeneratedNumber].invoiceReceivingDate).format(dateFormat)}</div>)
                //     } else {
                //         return 'NA';
                //     }
                // }
            },
            // {
            //     title: 'Net Comm Received',
            //     key: 'commReceived',
            //     dataIndex: 'commReceived',
            //     render: (item, record, index) => {
            //         if (editItem && editItem[index] == true && (record && record.cpUploadInvoice && record.cpUploadInvoice[0])) {
            //             return (<div>
            //                 <Input type='number' onChange={(e) => {
            //                     let editItem = this.state.editItem;
            //                     // editItem[index] = false;
            //                     this.setState({ editItem });
            //                     invoiceDates[index].commReceived = e.target.value
            //                     this.setState({ invoiceDates });
            //                 }} value={item ? item : ''} />
            //             </div>)
            //         } else {
            //             if (generatedInvoicesList[record.invoiceGeneratedNumber] != undefined && generatedInvoicesList[record.invoiceGeneratedNumber].invoiceReceivingDate) {
            //                 return (<div>{generatedInvoicesList[record.invoiceGeneratedNumber].commReceived}</div>)
            //             } else if (item && item != null) {
            //                 return (<div>{item ? item : ''}</div>)
            //             } else {
            //                 return 'NA';
            //             }
            //         }
            //     }
            // },
            // {
            //     title: 'Invoice Status',
            //     key: 'invoiceStatus',
            //     dataIndex: 'invoiceStatus',
            //     render: (item, record) => {
            //         let invoiceStatusClass = '#ffcc00';
            //         if (generatedInvoicesList[record.invoiceGeneratedNumber] != undefined) {
            //             if (['Paid by Uni', 'Cleared'].includes(generatedInvoicesList[record.invoiceGeneratedNumber].invoiceStatus)) {
            //                 invoiceStatusClass = 'green';
            //             } else if (['Approved by Uni'].includes(generatedInvoicesList[record.invoiceGeneratedNumber].invoiceStatus)) {
            //                 invoiceStatusClass = 'blue';
            //             } else if (['Generated', 'Submitted to Uni'].includes(generatedInvoicesList[record.invoiceGeneratedNumber].invoiceStatus)) {
            //                 invoiceStatusClass = '#ffcc00';
            //             }
            //         }
            //         if (generatedInvoicesList[record.invoiceGeneratedNumber] != undefined && generatedInvoicesList[record.invoiceGeneratedNumber].invoiceStatus) {
            //             return (<div style={{ backgroundColor: invoiceStatusClass, color: 'white', padding: '10px', borderRadius: '10px', textAlign: 'center' }}>{generatedInvoicesList[record.invoiceGeneratedNumber].invoiceStatus}</div>)
            //         } else {
            //             return 'NA';
            //         }
            //     }
            // },
            {
                title: `Upload College/University/Channel Partner Inv`,
                key: 'cpUploadInvoice',
                render: (text, record) => {
                    return (
                        <div>
                            {/* {
                                                    record.cpUploadInvoice && record.cpUploadInvoice[0] && record.cpUploadInvoice[0].url ?
                                                    <p><a target='_blank' href={MEDIA_URL + '' + record.cpUploadInvoice[0].url}>View</a></p>
                                                    : null
                                                    } */}
                            {
                                (record.cpInvoiceNumber || record.invoiceGeneratedNumber) && record.cpUploadInvoice && record.cpUploadInvoice.length > 0 ?
                                    <p><b>No: </b>{record.cpInvoiceNumber ? record.cpInvoiceNumber : record.invoiceGeneratedNumber}</p>
                                    : null
                            }
                            {
                                record.cpReceiptUpload && record.cpReceiptUpload[0] && record.cpReceiptUpload[0].url ?
                                    <p><b>Receipt: </b><a target='_blank' href={MEDIA_URL + '' + record.cpReceiptUpload[0].url}>View</a></p>
                                    : null
                            }
                            <Button onClick={(e) => {
                                this.setState({
                                    invoiceGeneratedId: record._id,
                                    showGeneratedCPInvoiceData: true,
                                    uploaded: true
                                }, () => {
                                    setTimeout(() => {
                                        this.props.form.setFieldsValue({
                                            cpUploadInvoice: record.cpUploadInvoice,
                                            commReceived: record.commReceived,
                                            conversionRate: record.conversionRate,
                                            totalAfterConversion: record.totalAfterConversion,
                                            cpPaymentReceivingBank: record.cpPaymentReceivingBank,
                                            cpInvoiceNumber: record.cpInvoiceNumber,
                                            cpReceiptUpload: record.cpReceiptUpload ? record.cpReceiptUpload : [],
                                        });
                                    }, 1000)
                                })
                            }} icon={<UploadOutlined />}>
                                {
                                    record.cpInvoiceNumber ? 'Update' : 'Upload'}
                            </Button>
                        </div>
                    )
                }
            },
            {
                title: 'Upload Branch/Sub Agent Invoice',
                key: 'apUploadInvoice',
                render: (item, record) => {
                    return (
                        <div>

                            {
                                record.apUploadInvoice && record.apUploadInvoice[0] && record.apUploadInvoice[0].url ?
                                    <p><a target='_blank' href={MEDIA_URL + '' + record.apUploadInvoice[0].url}>View</a></p>
                                    : null
                            }
                            {
                                record.apInvoiceNumber ?
                                    <p><b>No: </b>{record.apInvoiceNumber}</p>
                                    : null
                            }
                            {
                                record.apReceiptUpload && record.apReceiptUpload[0] && record.apReceiptUpload[0].url ?
                                    <p><b>Payment Advise: </b><a target='_blank' href={MEDIA_URL + '' + record.apReceiptUpload[0].url}>View</a></p>
                                    : null
                            }
                            <Button onClick={(e) => {
                                this.setState({
                                    invoiceGeneratedId: record._id,
                                    showGeneratedInvoiceData: true,
                                    uploaded: true
                                }, () => {
                                    setTimeout(() => {
                                        this.props.form.setFieldsValue({
                                            apUploadInvoice: record.apUploadInvoice,
                                            apInvoiceNumber: record.apInvoiceNumber,
                                            apReceiptUpload: record.apReceiptUpload ? record.apReceiptUpload : [],
                                        });
                                    }, 1000)
                                })
                            }} icon={<UploadOutlined />}>
                                {
                                    record.apInvoiceNumber ? 'Update' : 'Upload'}
                            </Button>
                        </div>
                    )
                }
            },
            {
                title: 'Action',
                key: 'operation',
                render: (val, record, index) => {
                    let createInvoiceUrl = `/account-desk?invId=${(record._id)}`;
                    return <React.Fragment>
                        {
                            !record.invoiceGeneratedNumber ?
                                <>
                                    <Button
                                        size={'small'}
                                        onClick={() => {
                                            let editItem = this.state.editItem;

                                            if (editItem[index] == undefined) {
                                                editItem[index] = true;
                                            } else {
                                                editItem[index] = true;
                                            }
                                            this.setState({ editItem });
                                        }}>
                                        <Icon type={'edit'}></Icon>
                                    </Button>

                                    <a
                                        target={"_blank"}
                                        href={createInvoiceUrl}
                                    >
                                        <Button size={'small'}><Icon type={'plus'}></Icon></Button>
                                    </a>

                                </>
                                : <>
                                    <Button
                                        size={'small'}
                                        onClick={() => {
                                            let editItem = this.state.editItem;

                                            if (editItem[index] == undefined) {
                                                editItem[index] = true;
                                            } else {
                                                editItem[index] = true;
                                            }
                                            this.setState({ editItem });
                                        }}>
                                        <Icon type={'edit'}></Icon>
                                    </Button>
                                    <Tooltip title="Send Invoice to Recipient"><Button onClick={() => { this.sendInvoice(record._id) }} size='small' icon='forward' shape='circle'></Button></Tooltip>
                                    {/* <Button size={'small'} onClick={() => {
                                                                if (record.invoiceGeneratedNumber && record.uploaded == false) {
                                                                this.loadInvoiceDetail(record.invoiceGeneratedNumber);
                                                                } else {
                                                                    window.open(MEDIA_URL + record.cpUploadInvoice[0].url, '_blank');
                                                                }
                                                                }}>
                                                                View Invoice
                                                                </Button> */}

                                    {/* <Button size={'small'} onClick={() => { this.loadInvoiceDetail(record.invoiceGeneratedNumber) }}>View Invoice</Button> */}

                                </>
                        }
                        {/* <Button size='small' icon='forward'></Button> */}
                        <RightsWrapper myRight={"ClaimDesk.delete"}>
                            <Button size={'small'} onClick={() => {
                                invoiceDates.splice(index, 1)
                                this.setState({ invoiceDates })
                            }}><Icon type={'delete'}></Icon></Button>
                        </RightsWrapper>
                        <Tooltip title="Withdraw Student" >
                            <Button size={'small'} onClick={() => {
                                this.setState({ recordId: { _id: info._id }, invoiceGenerationRecord: record, showWithdrawForm: true })
                            }} icon='cross'></Button>
                        </Tooltip>
                    </React.Fragment>
                }
            }
        ];

        const branchColumns = [
            {
                title: 'Term No',
                key: 'invoiceNo',
                width: 80,
                render: (item, record, key) => {
                    return key + 1
                }
            },
            {
                title: 'Invoice Generation Dates',
                key: 'generationDate',
                width: 180,
                dataIndex: 'generationDate',
                render: (item, record, index) => {
                    if (editItem && editItem[index] == true) {
                        return (<div>
                            <Input type='date' onChange={(e) => {
                                let editItem = this.state.editItem;
                                // editItem[index] = false;
                                this.setState({ editItem });
                                invoiceDates[index].generationDate = moment(e.target.value).toDate();
                                this.setState({ invoiceDates });
                            }} value={item ? moment(item).format('YYYY-MM-DD') : ''} />
                        </div>)
                    } else {
                        return (<div>{item ? moment(item).format(dateFormat) : ''}</div>)
                    }
                }
            },
            {
                title: 'Branch Share',
                key: 'commReceived',
                dataIndex: 'commReceived',
                width: 120,
                render: (item, record, index) => {
                    let { info } = this.state;
                    let totalAmount = 0;
                    if (record.uploaded === false && record.invoiceGeneratedNumber) {
                        let generatedInvoice = generatedInvoicesList[record.invoiceGeneratedNumber];
                        let foundGeneratedInvoice = generatedInvoice.invoices.find(obj => {
                            return obj.studentId === record._id;
                        });
                        totalAmount = foundGeneratedInvoice.commissionTotal;
                    } else if (item && item != null) {
                        totalAmount = item;
                    }
                    let branchShareAmount = (totalAmount * this.state.branchShare) / 100;
                    return (
                        <div>{branchShareAmount} {info && info.visaDesk && info.visaDesk.selectedCourse && info.visaDesk.selectedCourse.currency}</div>
                    )
                }
            },
            {
                title: 'University Invoice Status',
                key: 'invoiceStatus',
                dataIndex: 'invoiceStatus',
                width: 180,
                render: (item, record, index) => {
                    if (editItem && editItem[index] == true && (record && record.cpUploadInvoice && record.cpUploadInvoice[0] || record.apUploadInvoice[0])) {
                        return (<div>
                            <Select onChange={(invoiceStatus) => {
                                let editItem = this.state.editItem;
                                this.setState({ editItem });
                                invoiceDates[index].invoiceStatus = invoiceStatus;
                                this.setState({ invoiceDates });
                            }} value={item}>
                                <Option value={"Generated"}>Generated</Option>
                                <Option value={"Submitted to Uni"}>Submitted to Uni</Option>
                                <Option value={"Approved by Uni"}>Approved by Uni</Option>
                                <Option value={"Paid by Uni"}>Paid by Uni</Option>
                                <Option value={"Cleared"}>Cleared</Option>
                            </Select>

                        </div>)
                    } else {
                        if (generatedInvoicesList[record.invoiceGeneratedNumber] != undefined && generatedInvoicesList[record.invoiceGeneratedNumber].invoiceGeneratedDate) {
                            let invoiceStatusClass = '#ffcc00';
                            let getStatusWeight = (s) => {
                                const st = (s || '').toLowerCase().trim();
                                if (['cleared', 'paid by uni', 'completed'].includes(st)) return 4;
                                if (st === 'approved by uni') return 3;
                                if (st === 'submitted to uni') return 2;
                                if (st === 'generated') return 1;
                                return 0;
                            };

                            if (generatedInvoicesList[record.invoiceGeneratedNumber] != undefined) {
                                let genStatus = generatedInvoicesList[record.invoiceGeneratedNumber].invoiceStatus || "Pending";
                                let dbStatus = item || "Pending";
                                let actualStatus = getStatusWeight(dbStatus) >= getStatusWeight(genStatus) ? dbStatus : genStatus;

                                if (['Paid by Uni', 'Cleared'].includes(actualStatus)) {
                                    invoiceStatusClass = 'green';
                                } else if (['Approved by Uni'].includes(actualStatus)) {
                                    invoiceStatusClass = 'blue';
                                } else if (['Generated', 'Submitted to Uni'].includes(actualStatus)) {
                                    invoiceStatusClass = '#ffcc00';
                                }
                                return (<div style={{ backgroundColor: invoiceStatusClass, color: 'white', padding: '10px', borderRadius: '10px', textAlign: 'center' }}>{actualStatus}</div>)
                            } else {
                                return 'NA';
                            }
                        } else if (item && item != null) {
                            let invoiceStatusClass = '#ffcc00';
                            if (['Paid by Uni', 'Cleared'].includes(item)) {
                                invoiceStatusClass = 'green';
                            } else if (['Approved by Uni'].includes(item)) {
                                invoiceStatusClass = 'blue';
                            } else if (['Generated', 'Submitted to Uni'].includes(item)) {
                                invoiceStatusClass = '#ffcc00';
                            }
                            if (item) {
                                return (<div style={{ backgroundColor: invoiceStatusClass, color: 'white', padding: '10px', borderRadius: '10px', textAlign: 'center' }}>{item && item === "Paid by Uni" ? "Commission Received" : item}</div>)
                            }
                        } else {
                            return 'NA';
                        }
                    }
                }
            },
            {
                title: 'Invoice Clearance Date',
                key: 'invoiceReceivedDate',
                dataIndex: 'invoiceReceivedDate',
                render: (item, record, index) => {
                    if (editItem && editItem[index] == true && (record && record.cpUploadInvoice && record.cpUploadInvoice[0] || record.apUploadInvoice[0])) {
                        return (<div>
                            <Input type='date' onChange={(e) => {
                                let editItem = this.state.editItem;
                                // editItem[index] = false;
                                this.setState({ editItem });
                                invoiceDates[index].invoiceReceivedDate = moment(e.target.value).toDate();
                                this.setState({ invoiceDates });
                            }} value={item ? moment(item).format('YYYY-MM-DD') : ''} />
                        </div>)
                    } else {
                        if (generatedInvoicesList[record.invoiceGeneratedNumber] != undefined && generatedInvoicesList[record.invoiceGeneratedNumber].invoiceReceivingDate) {
                            return (<div>{moment(generatedInvoicesList[record.invoiceGeneratedNumber].invoiceReceivingDate).format(dateFormat)}</div>)
                        } else if (item && item != null) {
                            return (<div>{item ? moment(item).format(dateFormat) : ''}</div>)
                        } else {
                            return 'NA';
                        }
                    }
                },
            },
            // {
            //     title: 'Generate Your Invoice',
            //     key: 'apUploadInvoice',
            //     render: (item, record) => {
            //         return (
            //             <div>
            //                 {
            //                     record.apUploadInvoice && record.apUploadInvoice[0] && record.apUploadInvoice[0].url ?
            //                         <p><b>AP Invoice: </b><a target='_blank' href={MEDIA_URL + '' + record.apUploadInvoice[0].url}>View</a></p>
            //                         : null
            //                 }
            //                 {
            //                     record.apInvoiceNumber ?
            //                         <p><b>AP Invoice Number: </b>{record.apInvoiceNumber}</p>
            //                         : null
            //                 }
            //                 {
            //                     record.apReceiptUpload && record.apReceiptUpload[0] && record.apReceiptUpload[0].url ?
            //                         <p><b>AP Receipt: </b><a target='_blank' href={MEDIA_URL + '' + record.apReceiptUpload[0].url}>View</a></p>
            //                         : null
            //                 }
            //                 <Button icon='download' onClick={(e) => {
            //                     this.setState({
            //                         invoiceGeneratedId: record._id,
            //                         showGeneratedInvoiceData: true,
            //                         uploaded: true
            //                     }, () => {
            //                         setTimeout(() => {
            //                             this.props.form.setFieldsValue({
            //                                 apUploadInvoice: record.apUploadInvoice,
            //                                 apInvoiceNumber: record.apInvoiceNumber,
            //                                 apReceiptUpload: record.apReceiptUpload,
            //                             });
            //                         }, 1000)
            //                     })
            //                 }} >
            //                     {/* {
            //                                                         record.apInvoiceNumber ? 'Update' : 'Upload'} */}
            //                 </Button>
            //             </div>
            //         )
            //     }
            // },
        ]

        const inputSchemaINCP = {
            fields: [
                {
                    label: 'Upload Invoice',
                    key: 'cpUploadInvoice',
                    type: 'file',
                    required: true
                },
                {
                    label: 'Invoice Number',
                    key: 'cpInvoiceNumber',
                    type: 'text',
                    required: true
                },
                {
                    label: 'Commission Amount (Base Currency)',
                    key: 'commReceived',
                },
                {
                    label: 'Conversion Rate (if applicable)',
                    key: 'conversionRate',
                    type: 'number',
                    onChange: value =>
                        this.handleConversionCalculation(value, 'conversionRate')
                },
                {
                    label: 'Converted Commission Amount',
                    key: 'totalAfterConversion',
                    type: 'number',
                    disabled: true
                },
                {
                    label: 'Payment Proof / Receipt',
                    key: 'cpReceiptUpload',
                    type: 'file',
                },
                {
                    label: 'Receiving Bank',
                    key: 'cpPaymentReceivingBank',
                    type: 'select',
                    options: this.state.bankDetails,
                    onChange: v => {
                        this.props.form.setFieldsValue({ cpPaymentReceivingBank: v })
                    }
                }
            ]
        }

        const inputSchemaINV = {
            fields: [
                {
                    label: 'Upload Invoice',
                    key: 'apUploadInvoice',
                    type: 'file',
                },
                {
                    label: 'Invoice Number',
                    key: 'apInvoiceNumber',
                    type: 'text',
                },
                {
                    label: 'Payment Record',
                    key: 'apReceiptUpload',
                    type: 'file',
                    hidden: claimDeskRights && claimDeskRights.viewByBranch ? true : false
                }
            ]
        }

        const commentBox = {
            fields: [

                {
                    label: 'Select Status',
                    key: 'status',
                    type: 'select',
                    customProps: {
                        style: {
                            width: '60%'
                        }
                    },
                    options: ['Invoice Pending for Payment at University', 'Invoice Paid by the University', 'Invoice not cleared by University – Bad Debts'],
                    onChange: v => {
                        this.props.form.setFieldsValue({ status: v })

                        if (v === 'Invoice Paid by the University') {
                            if (singleDueInvoice && singleDueInvoice.invoiceNo == 1 || singleDueInvoice.invoiceNo == 2) {
                                this.setState({ showBranchCommission: true, changeStatusValue: false }, () => {
                                    form.setFieldsValue({ branchCommission: branchCommissionValue })
                                })
                            } else {
                                this.setState({ changeStatusValue: false })
                            }

                        } else if (v === 'Invoice not cleared by University – Bad Debts') {
                            this.setState({ changeStatusValue: true, showBranchCommission: false })

                        } else {
                            this.setState({ changeStatusValue: false, showBranchCommission: false })

                        }
                    }
                },
                {
                    label: 'Branch Commission ', key: 'branchCommission', type: 'number',
                    hidden: this.state.showBranchCommission ? false : true,
                    required: this.state.showBranchCommission ? true : false,

                    rightComp: <span style={{ paddingLeft: '5px' }}>%</span>
                },

                {
                    label: 'Comment',
                    key: 'comment',
                    type: 'textArea',
                    rows: 5,
                    required: this.state.changeStatusValue ? true : false,
                    customProps: {
                        style: {
                            width: '55%'
                        }
                    },
                    hidden: this.state.changeStatusValue ? false : true
                }

            ]
        }

        let universityView = rightAuth.checkRights('financeUniversityCommission.view');
        function formatAmount(amount, currency) {
            if (amount === null || amount === undefined) {
                return "NA";
            }
            const roundedAmount = Number(amount).toFixed(2);
            return currency ? currency + " " + roundedAmount : roundedAmount;
        }
        return (
            <PageHeaderWrapper title={'Claim Desk'}>
                {
                    showWithdrawForm ?
                        <WithdrawStudentReasonForm onClose={this.closeWithdrawFrom} onSelect={(e) => this.withdrawStudent(e)} recordId={recordId} invoiceGenerationRecord={invoiceGenerationRecord} enableBTN={enableBTN} />
                        : null
                }
                {
                    this.state.showInvoiveInboxView ?
                        <InboxEmailView invoiceId={invoiceId} onClose={this.closeInvoiceInbox} />
                        : null
                }
                {
                    this.state.showApChangeDrawer ?
                        <ChangeAp inquiryId={this.state.inquiryId} onClose={this.closeChangeAp} />
                        : null
                }
                {
                    this.state.showCpChangeDrawer ?
                        <ChangeCp inquiryId={this.state.inquiryId} onClose={this.closeChangeCp} />
                        : null
                }
                {
                    ext != null && linkUrl !== null ?
                        <PDFFileView linkUrl={linkUrl} ext={ext} onClose={this.closeDocument} />
                        : null
                }
                {/* {
                                                                    ext != null && universityData && universityData.paymentUpload && universityData.paymentUpload.length > 0 ?
                                                                    <PDFFileView linkUrl={linkUrl} ext={ext} onClose={this.closeDocument} />
                                                                    : null
                                                                    } */}
                <Spin spinning={this.state.loader}>
                    <Form onSubmit={this.handleSubmit} hideRequiredMark>

                        {
                            info && info._id ? <div style={{ marginBottom: 10 }}>
                                <StudentHeader
                                    info={this.state.inquiryId}
                                    rollBackLevel={'Visa Desk'}
                                    data={info}
                                    done={() => {
                                        dispatch(getUrlPushWrapper('desk.claim'))
                                    }}
                                    dispatch={this.props.dispatch}
                                />
                            </div> : null
                        }

                        {
                            info ? <Card bordered={true} style={{ marginBottom: 10 }}>
                                <StudentInfo
                                    info={info}

                                />
                            </Card> : null
                        }

                        <Card>
                            <Row>
                                {/* <Col span={24}>
                                                                        <Descriptions title="Student Info" bordered size="small" column={2}>
                                                                        <Descriptions.Item label="VID">{info && info.id}</Descriptions.Item>
                                                                        <Descriptions.Item label="Branch Head - Branch">{branchData && branchData.branchHeadName ? branchData.branchHeadName + ' - ' + branchData.branchName : 'NA'}</Descriptions.Item>
                                                                        <Descriptions.Item label="Student Name">{info && info.studentName}</Descriptions.Item>
                                                                        <Descriptions.Item label="Counsellor">{info && info.counsellorId.name}</Descriptions.Item>
                                                                        <Descriptions.Item label="Passport No.">{info && info.profile && info.profile.passportNumber ? info.profile.passportNumber : 'NA'}</Descriptions.Item>
                                                                        <Descriptions.Item label="Channel Partner">
                                                                        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                                                                        
                                                                        
                                                                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
                                                                        {showChannelPartner === true ? (
                                                                        visaDesk && visaDesk.selectedCourse && visaDesk.selectedCourse.channelPartnerName ? (
                                                                        <span style={{ fontWeight: 600, fontSize: '15px', color: '#262626' }}>
                                                                        {visaDesk.selectedCourse.channelPartnerName}
                                                                        </span>
                                                                        ) : (
                                                                        <span style={{ color: '#bfbfbf', fontStyle: 'italic' }}>NA</span>
                                                                        )
                                                                        ) : (
                                                                        <Tag color="green">Yes</Tag>
                                                                        )}
                                                                        </div>
                                                                        
                                                                        
                                                                        {visaDesk && visaDesk.partnerUpdatedBy && (
                                                                        <div style={{
                                                                        padding: '4px 8px',
                                                                        background: '#f9f9f9',
                                                                        borderRadius: '4px',
                                                                        fontSize: '11px',
                                                                        color: '#8c8c8c',
                                                                        border: '1px solid #f0f0f0'
                                                                        }}>
                                                                        <Icon type="history" style={{ marginRight: 5 }} />
                                                                        Updated by <b>{visaDesk.partnerUpdatedBy.name}</b> on {moment(visaDesk.partnerUpdatedBy.time).format('DD MMM YYYY, hh:mm A')}
                                                                        </div>
                                                                        )}
                                                                        
                                                                        
                                                                        <RightsWrapper myRight={"changeAssociatePartner.view"}>
                                                                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginTop: '4px' }}>
                                                                        <Button
                                                                        type={visaDesk && visaDesk.selectedCourse && visaDesk.selectedCourse.channelPartnerId ? "default" : "primary"}
                                                                        size="small"
                                                                        icon={visaDesk && visaDesk.selectedCourse && visaDesk.selectedCourse.channelPartnerId ? "edit" : "plus"}
                                                                        onClick={() => this.showChangeCP()}
                                                                        >
                                                                        {visaDesk && visaDesk.selectedCourse && visaDesk.selectedCourse.channelPartnerId
                                                                        ? "Update Partner"
                                                                        : "Add Partner"}
                                                                        </Button>
                                                                        
                                                                        {visaDesk && visaDesk.selectedCourse && visaDesk.selectedCourse.channelPartnerId && (
                                                                        <React.Fragment>
                                                                        
                                                                        {visaDesk.channelPartnerDetails && visaDesk.channelPartnerDetails.paymentUpload && visaDesk.channelPartnerDetails.paymentUpload.length > 0 && (
                                                                        <Tooltip title="View Payment Details">
                                                                        <Button
                                                                        icon="eye"
                                                                        type="primary"
                                                                        size="small"
                                                                        style={{ background: '#52c41a', borderColor: '#52c41a' }}
                                                                        onClick={() => this.viewPDF(visaDesk.channelPartnerDetails.paymentUpload)}
                                                                        />
                                                                        </Tooltip>
                                                                        )}
                                                                        
                                                                        
                                                                        <Tooltip title="Remove Partner">
                                                                        <Popconfirm
                                                                        title="Are you sure you want to remove this Channel Partner?"
                                                                        onConfirm={() => this.handleRemoveCP(info._id)}
                                                                        okText="Yes"
                                                                        cancelText="No"
                                                                        >
                                                                        <Button
                                                                        type="danger"
                                                                        size="small"
                                                                        ghost
                                                                        shape="circle"
                                                                        icon="delete"
                                                                        style={{ fontSize: '12px' }}
                                                                        />
                                                                        </Popconfirm>
                                                                        </Tooltip>
                                                                        </React.Fragment>
                                                                        )}
                                                                        </div>
                                                                        </RightsWrapper>
                                                                        </div>
                                                                        </Descriptions.Item>
                                                                        <Descriptions.Item label="DOB">{info && info.dateOfBirth ? moment(info.dateOfBirth).format(dateFormat) : ''}</Descriptions.Item>
                                                                        <Descriptions.Item label="Sub Agent">
                                                                        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                                                                        
                                                                        
                                                                        <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: '8px' }}>
                                                                        {info && info.associatePartnerName ? (
                                                                        <>
                                                                        <span style={{ fontWeight: 600, fontSize: '15px', color: '#262626' }}>
                                                                        {info.associatePartnerName}
                                                                        </span>
                                                                        {info.associatePartnerPlan && (
                                                                        <Tag color="blue" style={{ margin: 0 }}>{info.associatePartnerPlan}</Tag>
                                                                        )}
                                                                        </>
                                                                        ) : (
                                                                        <span style={{ color: '#bfbfbf', fontStyle: 'italic' }}>Not Assigned</span>
                                                                        )}
                                                                        </div>
                                                                        
                                                                        {info && info.agentUpdatedBy && (
                                                                        <div style={{
                                                                        padding: '4px 8px',
                                                                        background: '#f5f5f5',
                                                                        borderRadius: '4px',
                                                                        fontSize: '11px',
                                                                        color: '#8c8c8c',
                                                                        lineHeight: '1.4'
                                                                        }}>
                                                                        <Icon type="history" style={{ marginRight: 5 }} />
                                                                        Updated by <b>{info.agentUpdatedBy.name}</b> on {moment(info.agentUpdatedBy.time).format('DD MMM YYYY, hh:mm A')}
                                                                        </div>
                                                                        )}
                                                                        
                                                                        
                                                                        <RightsWrapper myRight={"changeAssociatePartner.view"}>
                                                                        <div style={{ display: 'flex', gap: '8px', marginTop: '4px' }}>
                                                                        <Button
                                                                        type={info && info.associatePartnerName ? "default" : "primary"}
                                                                        size="small"
                                                                        icon={info && info.associatePartnerName ? "edit" : "plus"}
                                                                        onClick={() => this.showChangeAP()}
                                                                        >
                                                                        {info && info.associatePartnerName ? "Change Subagent" : "Add Subagent"}
                                                                        </Button>
                                                                        
                                                                        {info && info.associatePartnerName && info.associatePartnerAgreement && (
                                                                        <Tooltip title="View Agreement">
                                                                        <Button
                                                                        type="primary"
                                                                        size="small"
                                                                        icon="file-pdf"
                                                                        onClick={() => this.viewPDF(info.associatePartnerAgreement)}
                                                                        style={{ background: '#52c41a', borderColor: '#52c41a' }} 
                                                                        />
                                                                        </Tooltip>
                                                                        )}
                                                                        </div>
                                                                        </RightsWrapper>
                                                                        </div>
                                                                        </Descriptions.Item>
                                                                        <Descriptions.Item label="Institute Student Id">{visaDesk && visaDesk.selectedCourse && visaDesk.selectedCourse.instituteStudentId}</Descriptions.Item>
                                                                        <Descriptions.Item label="Funds Trfd as per SWIFT">{visaDesk && visaDesk.selectedCourse && visaDesk.selectedCourse.currency} {visaDesk && visaDesk.selectedCourse && visaDesk.selectedCourse.totalSwiftAmount}
                                                                        {
                                                                        visaDesk && visaDesk.selectedCourse && visaDesk.selectedCourse.vendorPaymentProof && visaDesk.selectedCourse.vendorPaymentProof.length > 0 ? (
                                                                        <Descriptions.Item label="Full Agreement">
                                                                        <Tooltip title={visaDesk && visaDesk.selectedCourse && visaDesk.selectedCourse.vendorPaymentReceiptType ? `View ${visaDesk.selectedCourse.vendorPaymentReceiptType}` : 'View Payment Proof'}>
                                                                        <Button style={{ marginLeft: 10 }} icon='eye' type='primary' onClick={() => this.viewPDF(visaDesk.selectedCourse.vendorPaymentProof)} />
                                                                        </Tooltip>
                                                                        </Descriptions.Item>
                                                                        )
                                                                        : null
                                                                        }
                                                                        </Descriptions.Item>
                                                                        <Descriptions.Item label="Email">{info && info.emailId}</Descriptions.Item>
                                                                        <Descriptions.Item label="Prepaid Tution Fee (Net)">{visaDesk && visaDesk.selectedCourse && visaDesk.selectedCourse.currency} {visaDesk && visaDesk.selectedCourse && visaDesk.selectedCourse.tutionFee}</Descriptions.Item>
                                                                        <Descriptions.Item label="Visa Approval Date">{info && info.visaDesk && info.visaDesk.visaApprovalDate ? moment(info.visaDesk.visaApprovalDate).format(dateFormat) : ''}</Descriptions.Item>
                                                                        <Descriptions.Item label="Course/Duration">{visaDesk && visaDesk.selectedCourse && visaDesk.selectedCourse.courseName} ({visaDesk && visaDesk.selectedCourse && visaDesk.selectedCourse.courseDetails && visaDesk.selectedCourse.courseDetails.courseDuration ? visaDesk.selectedCourse.courseDetails.courseDuration : ""})
                                                                        {
                                                                        finalOfferLetter ?
                                                                        (
                                                                        <Descriptions.Item label="Offer Letter">
                                                                        <Tooltip title={`View Offer Letter`}>
                                                                        <Button style={{ marginLeft: 10 }} icon='eye' type='primary' onClick={() => this.viewPDF(finalOfferLetter)} />
                                                                        </Tooltip>
                                                                        </Descriptions.Item>
                                                                        )
                                                                        : null
                                                                        }
                                                                        </Descriptions.Item>
                                                                        <Descriptions.Item label="Course Start Date">{visaDesk && visaDesk.courseStartDate ? moment(visaDesk.courseStartDate).format(dateFormat) : ''}</Descriptions.Item>
                                                                        <Descriptions.Item label="College/Campus/Country">
                                                                        {
                                                                        visaDesk && visaDesk.selectedCourse &&
                                                                        [
                                                                        visaDesk.selectedCourse.universityInstitutionName,
                                                                        visaDesk.selectedCourse.campusName,
                                                                        visaDesk.selectedCourse.countryName
                                                                        ]
                                                                        .filter(item => item)
                                                                        .join(' / ')
                                                                        }
                                                                        
                                                                        {
                                                                        showChannelPartner == true && visaDesk && visaDesk.selectedCourse &&
                                                                        visaDesk.selectedCourse.channelPartnerName &&
                                                                        visaDesk.selectedCourse.channelPartnerId ? (
                                                                        <Descriptions.Item label="Full Agreement">
                                                                        <Button onClick={() => this.viewPDF(channelPartnerAgreement)}>
                                                                        Full Agreement
                                                                        </Button>
                                                                        </Descriptions.Item>
                                                                        ) : universityData && universityData.paymentUpload && universityData.paymentUpload.length > 0 && universityView ? (
                                                                        <Descriptions.Item label="Full Agreement">
                                                                        <Button onClick={() => this.viewPDF(universityData.paymentUpload)}>
                                                                        Full Agreement
                                                                        </Button>
                                                                        </Descriptions.Item>
                                                                        ) : null
                                                                        }
                                                                        
                                                                        {
                                                                        showChannelPartner == true && visaDesk && visaDesk.selectedCourse &&
                                                                        visaDesk.selectedCourse.channelPartnerName &&
                                                                        visaDesk.selectedCourse.channelPartnerId ? (
                                                                        <Descriptions.Item label="View Agreement Commission Page">
                                                                        <Tooltip title="View Commission Page">
                                                                        <Button onClick={() => this.viewPDF(channelPartnerAgreementCommission)} icon='eye' type='primary'></Button>
                                                                        </Tooltip>
                                                                        </Descriptions.Item>
                                                                        ) : universityData && universityData.paymentUploadCommissionPage && universityData.paymentUploadCommissionPage.length > 0 && universityView ? (
                                                                        <Descriptions.Item label="View Agreement Commission Page">
                                                                        <Tooltip title="View Commission Page">
                                                                        <Button onClick={() => this.viewPDF(universityData.paymentUploadCommissionPage)} icon='eye' type='primary'></Button>
                                                                        </Tooltip>
                                                                        </Descriptions.Item>
                                                                        ) : null
                                                                        }
                                                                        </Descriptions.Item>
                                                                        
                                                                        <Descriptions.Item label="Expected Travel Date">{visaDesk && visaDesk.arrivalDate ? moment(visaDesk.arrivalDate).format(dateFormat) : "NA"}</Descriptions.Item>
                                                                        <Descriptions.Item label="Registration Date">{info && info.createdByUser && info.createdByUser.time ? moment(info.createdByUser.time).format(dateFormat) : "NA"}</Descriptions.Item>
                                                                        <Descriptions.Item label="Student Status"><Button style={{ background: this.getStudentStatus(info).color, color: "#fff" }}>{this.getStudentStatus(info).label}</Button></Descriptions.Item>
                                                                        <Descriptions.Item label="Consultancy Balance">
                                                                        {info &&
                                                                        info.registrationDesk &&
                                                                        info.registrationDesk.balance !== undefined &&
                                                                        info.registrationDesk.balance !== null
                                                                        ? info.registrationDesk.balance
                                                                        : info &&
                                                                        info.registrationDesk &&
                                                                        info.registrationDesk.mode}
                                                                        </Descriptions.Item>
                                                                        
                                                                        
                                                                        
                                                                        
                                                                        </Descriptions>
                                                                        
                                                                        </Col> */}
                                <Col span={24}>
                                    <div style={{ background: '#fff', borderRadius: '8px', overflow: 'hidden', boxShadow: '0 2px 8px rgba(0,0,0,0.05)' }}>
                                        <Descriptions
                                            title={<span style={{ borderLeft: '4px solid #1890ff', paddingLeft: '12px', color: '#262626' }}>Student Case Information</span>}
                                            bordered
                                            size="small"
                                            column={2}
                                            labelStyle={{ backgroundColor: '#fafafa', color: '#8c8c8c', fontWeight: 600, width: '20%' }}
                                            contentStyle={{ backgroundColor: '#fff', color: '#262626', fontSize: '13px' }}
                                        >
                                            <Descriptions.Item label="VID">
                                                <b style={{ color: '#1890ff' }}>{info && info.id}</b>
                                            </Descriptions.Item>

                                            <Descriptions.Item label="Branch Detail">
                                                {branchData && branchData.branchHeadName ? (
                                                    <span>
                                                        <Icon type="environment" style={{ color: '#ff4d4f', marginRight: 4 }} />
                                                        {branchData.branchHeadName} - <Tag color="blue" style={{ margin: 0 }}>{branchData.branchName}</Tag>
                                                    </span>
                                                ) : 'NA'}
                                            </Descriptions.Item>

                                            <Descriptions.Item label="Student Name">
                                                <span style={{ fontWeight: 600, fontSize: '14px' }}>{info && info.studentName}</span>
                                            </Descriptions.Item>

                                            <Descriptions.Item label="Counsellor">
                                                <Icon type="user" style={{ marginRight: 8, color: '#1890ff' }} />
                                                {info && info.counsellorId && info.counsellorId.name ? info.counsellorId.name : 'NA'}
                                            </Descriptions.Item>

                                            <Descriptions.Item label="Passport No.">
                                                <Tag color="cyan" style={{ margin: 0, fontWeight: 'bold' }}>
                                                    {info && info.profile && info.profile.passportNumber ? info.profile.passportNumber : 'NA'}
                                                </Tag>
                                            </Descriptions.Item>


                                            <Descriptions.Item label="Channel Partner">
                                                <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                                                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
                                                        {showChannelPartner ? (
                                                            visaDesk && visaDesk.selectedCourse && visaDesk.selectedCourse.channelPartnerName ? (
                                                                <span style={{ fontWeight: 600, fontSize: '14px', color: '#262626' }}>
                                                                    {visaDesk.selectedCourse.channelPartnerName}
                                                                </span>
                                                            ) : (
                                                                <span style={{ color: '#bfbfbf', fontStyle: 'italic' }}>NA</span>
                                                            )
                                                        ) : (
                                                            <Tag color="green">Active</Tag>
                                                        )}
                                                    </div>

                                                    {visaDesk && visaDesk.partnerUpdatedBy && (
                                                        <div style={{ padding: '4px 10px', background: '#f5f5f5', borderRadius: '4px', fontSize: '11px', color: '#8c8c8c', borderLeft: '2px solid #d9d9d9' }}>
                                                            <Icon type="history" style={{ marginRight: 5 }} />
                                                            Updated by <b>{visaDesk.partnerUpdatedBy.name}</b> on {moment(visaDesk.partnerUpdatedBy.time).format('DD MMM YYYY')}
                                                        </div>
                                                    )}

                                                    <RightsWrapper myRight={"changeAssociatePartner.view"}>
                                                        <div style={{ display: 'flex', gap: '8px', marginTop: '4px' }}>
                                                            <Button
                                                                type={visaDesk && visaDesk.selectedCourse && visaDesk.selectedCourse.channelPartnerId ? "default" : "primary"}
                                                                size="small"
                                                                icon={visaDesk && visaDesk.selectedCourse && visaDesk.selectedCourse.channelPartnerId ? "edit" : "plus"}
                                                                onClick={() => this.showChangeCP()}
                                                            >
                                                                {visaDesk && visaDesk.selectedCourse && visaDesk.selectedCourse.channelPartnerId ? "Update Partner" : "Add Partner"}
                                                            </Button>
                                                            {visaDesk && visaDesk.selectedCourse && visaDesk.selectedCourse.channelPartnerId && (
                                                                <React.Fragment>
                                                                    {visaDesk.channelPartnerDetails && visaDesk.channelPartnerDetails.paymentUpload && visaDesk.channelPartnerDetails.paymentUpload.length > 0 && (
                                                                        <Tooltip title="View Payment Details">
                                                                            <Button
                                                                                icon="eye"
                                                                                type="primary"
                                                                                size="small"
                                                                                style={{ background: '#52c41a', borderColor: '#52c41a' }}
                                                                                onClick={() => this.viewPDF(visaDesk.channelPartnerDetails.paymentUpload)}
                                                                            />
                                                                        </Tooltip>
                                                                    )}
                                                                    <Tooltip title="Remove Partner">
                                                                        <Popconfirm title="Remove Partner?" onConfirm={() => this.handleRemoveCP(info._id)} okText="Yes" cancelText="No">
                                                                            <Button type="danger" size="small" ghost shape="circle" icon="delete" style={{ fontSize: '12px' }} />
                                                                        </Popconfirm>
                                                                    </Tooltip>
                                                                </React.Fragment>
                                                            )}
                                                        </div>
                                                    </RightsWrapper>
                                                </div>
                                            </Descriptions.Item>

                                            <Descriptions.Item label="DOB">
                                                {info && info.dateOfBirth ? moment(info.dateOfBirth).format(dateFormat) : ''}
                                            </Descriptions.Item>


                                            <Descriptions.Item label="Sub Agent">
                                                <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                                                    <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: '8px' }}>
                                                        {info && info.associatePartnerName ? (
                                                            <>
                                                                <span style={{ fontWeight: 600, fontSize: '15px', color: '#262626' }}>{info.associatePartnerName}</span>
                                                                {info.associatePartnerPlan && <Tag color="blue" style={{ margin: 0 }}>{info.associatePartnerPlan}</Tag>}
                                                            </>
                                                        ) : (
                                                            <span style={{ color: '#bfbfbf', fontStyle: 'italic' }}>Not Assigned</span>
                                                        )}
                                                    </div>
                                                    {info && info.agentUpdatedBy && (
                                                        <div style={{ padding: '4px 8px', background: '#f5f5f5', borderRadius: '4px', fontSize: '11px', color: '#8c8c8c' }}>
                                                            <Icon type="history" style={{ marginRight: 5 }} />
                                                            Updated by <b>{info.agentUpdatedBy.name}</b> on {moment(info.agentUpdatedBy.time).format('DD MMM YYYY')}
                                                        </div>
                                                    )}
                                                    <RightsWrapper myRight={"changeAssociatePartner.view"}>
                                                        <div style={{ display: 'flex', gap: '8px', marginTop: '4px' }}>
                                                            <Button
                                                                type={info && info.associatePartnerName ? "default" : "primary"}
                                                                size="small"
                                                                icon={info && info.associatePartnerName ? "edit" : "plus"}
                                                                onClick={() => this.showChangeAP()}
                                                            >
                                                                {info && info.associatePartnerName ? "Change Subagent" : "Add Subagent"}
                                                            </Button>
                                                            {info && info.associatePartnerName && info.associatePartnerAgreement && (
                                                                <Tooltip title="View Agreement">
                                                                    <Button
                                                                        type="primary"
                                                                        size="small"
                                                                        icon="file-pdf"
                                                                        onClick={() => this.viewPDF(info.associatePartnerAgreement)}
                                                                        style={{ background: '#52c41a', borderColor: '#52c41a' }}
                                                                    />
                                                                </Tooltip>
                                                            )}
                                                        </div>
                                                    </RightsWrapper>
                                                </div>
                                            </Descriptions.Item>

                                            <Descriptions.Item label="Institute Student Id">
                                                <span style={{ fontWeight: 600 }}>{visaDesk && visaDesk.selectedCourse && visaDesk.selectedCourse.instituteStudentId}</span>
                                            </Descriptions.Item>

                                            <Descriptions.Item label="Funds Trfd (SWIFT)">
                                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                                    <span>
                                                        <b style={{ color: '#52c41a' }}>{visaDesk && visaDesk.selectedCourse && visaDesk.selectedCourse.currency}</b>{' '}
                                                        {visaDesk && visaDesk.selectedCourse && visaDesk.selectedCourse.totalSwiftAmount}
                                                    </span>
                                                    {visaDesk && visaDesk.selectedCourse && visaDesk.selectedCourse.vendorPaymentProof && visaDesk.selectedCourse.vendorPaymentProof.length > 0 && (
                                                        <Tooltip title={visaDesk.selectedCourse.vendorPaymentReceiptType || 'View Payment Proof'}>
                                                            <Button size="small" icon='eye' type='primary' onClick={() => this.viewPDF(visaDesk.selectedCourse.vendorPaymentProof)} />
                                                        </Tooltip>
                                                    )}
                                                </div>
                                            </Descriptions.Item>

                                            <Descriptions.Item label="Email">
                                                <a href={"mailto:" + (info && info.emailId)}>{info && info.emailId}</a>
                                            </Descriptions.Item>

                                            <Descriptions.Item label="Prepaid Tuition Fee">
                                                <b>{visaDesk && visaDesk.selectedCourse && visaDesk.selectedCourse.currency}</b>{' '}
                                                {visaDesk && visaDesk.selectedCourse && visaDesk.selectedCourse.tutionFee}
                                            </Descriptions.Item>

                                            <Descriptions.Item label="Visa Approval Date">
                                                {info && info.visaDesk && info.visaDesk.visaApprovalDate ? (
                                                    <span><Icon type="check-circle" style={{ color: '#52c41a', marginRight: 6 }} /> {moment(info.visaDesk.visaApprovalDate).format(dateFormat)}</span>
                                                ) : 'Pending'}
                                            </Descriptions.Item>

                                            <Descriptions.Item label="Course / Duration">
                                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                                    <span>
                                                        {visaDesk && visaDesk.selectedCourse && visaDesk.selectedCourse.courseName}{' '}
                                                        <small style={{ color: '#8c8c8c' }}>
                                                            ({visaDesk && visaDesk.selectedCourse && visaDesk.selectedCourse.courseDetails && visaDesk.selectedCourse.courseDetails.courseDuration ? visaDesk.selectedCourse.courseDetails.courseDuration : ""})
                                                        </small>
                                                    </span>
                                                    {finalOfferLetter && (
                                                        <Tooltip title="View Offer Letter">
                                                            <Button size="small" icon='eye' type='primary' onClick={() => this.viewPDF(finalOfferLetter)} />
                                                        </Tooltip>
                                                    )}
                                                </div>
                                            </Descriptions.Item>

                                            <Descriptions.Item label="Course Start Date">
                                                {visaDesk && visaDesk.courseStartDate ? moment(visaDesk.courseStartDate).format(dateFormat) : ''}
                                            </Descriptions.Item>

                                            <Descriptions.Item label="College / Campus" span={2}>
                                                <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
                                                    <div>
                                                        <Icon type="bank" style={{ marginRight: 8, color: '#8c8c8c' }} />
                                                        {visaDesk && visaDesk.selectedCourse &&
                                                            [
                                                                visaDesk.selectedCourse.universityInstitutionName,
                                                                visaDesk.selectedCourse.campusName,
                                                                visaDesk.selectedCourse.countryName
                                                            ].filter(item => item).join(' / ')
                                                        }
                                                    </div>
                                                    {/* Preserved Full Agreement / Commission Page Logic */}
                                                    <div style={{ display: 'flex', gap: '8px' }}>
                                                        {showChannelPartner && visaDesk && visaDesk.selectedCourse && visaDesk.selectedCourse.channelPartnerName && visaDesk.selectedCourse.channelPartnerId ? (
                                                            <Button size="small" onClick={() => this.viewPDF(channelPartnerAgreement)}>Full Agreement</Button>
                                                        ) : universityData && universityData.paymentUpload && universityData.paymentUpload.length > 0 && universityView ? (
                                                            <Button size="small" onClick={() => this.viewPDF(universityData.paymentUpload)}>Full Agreement</Button>
                                                        ) : null}

                                                        {showChannelPartner && visaDesk && visaDesk.selectedCourse && visaDesk.selectedCourse.channelPartnerName && visaDesk.selectedCourse.channelPartnerId ? (
                                                            <Tooltip title="View Commission Page">
                                                                <Button size="small" onClick={() => this.viewPDF(channelPartnerAgreementCommission)} icon='eye' type='primary' />
                                                            </Tooltip>
                                                        ) : universityData && universityData.paymentUploadCommissionPage && universityData.paymentUploadCommissionPage.length > 0 && universityView ? (
                                                            <Tooltip title="View Commission Page">
                                                                <Button size="small" onClick={() => this.viewPDF(universityData.paymentUploadCommissionPage)} icon='eye' type='primary' />
                                                            </Tooltip>
                                                        ) : null}
                                                    </div>
                                                </div>
                                            </Descriptions.Item>

                                            <Descriptions.Item label="Expected Travel Date">
                                                {visaDesk && visaDesk.arrivalDate ? (
                                                    <span><Icon type="rocket" style={{ marginRight: 8, color: '#1890ff' }} />{moment(visaDesk.arrivalDate).format(dateFormat)}</span>
                                                ) : "NA"}
                                            </Descriptions.Item>

                                            <Descriptions.Item label="Registration Date">
                                                {
                                                    info && info.registrationDesk && info.registrationDesk.registrationDate
                                                        ? moment(info.registrationDesk.registrationDate).format(dateFormat)
                                                        : "NA"
                                                }
                                            </Descriptions.Item>

                                            <Descriptions.Item label="Student Status">
                                                <Tag color={this.getStudentStatus(info).color} style={{ fontWeight: 600 }}>
                                                    {this.getStudentStatus(info).label.toUpperCase()}
                                                </Tag>
                                            </Descriptions.Item>

                                            <Descriptions.Item label="Consultancy Balance">
                                                <span style={{ fontSize: '15px', fontWeight: 700, color: (info && info.registrationDesk && info.registrationDesk.balance > 0) ? '#ff4d4f' : '#52c41a' }}>
                                                    {info && info.registrationDesk && info.registrationDesk.balance !== undefined && info.registrationDesk.balance !== null
                                                        ? `₹ ${info.registrationDesk.balance.toLocaleString()}`
                                                        : (info && info.registrationDesk && info.registrationDesk.mode)}
                                                </span>
                                            </Descriptions.Item>
                                        </Descriptions>
                                    </div>
                                </Col>
                                <Col span={24} style={{ marginTop: '20px' }}>

                                    {
                                        claimDeskRights && !claimDeskRights.viewByBranch &&
                                        <div>
                                            <Row>

                                                <Col span={15} style={{ paddingRight: '10px' }}>

                                                    <GetAllFormFields
                                                        apiurl={LAPI_URL}
                                                        inputSchema={inputSchema2}
                                                        getFieldDecorator={getFieldDecorator}
                                                        formItemLayout={{
                                                            labelCol: { span: 16 },
                                                            wrapperCol: { span: 8 }
                                                        }}
                                                    />

                                                </Col>

                                                {
                                                    invoiceDates && invoiceDates.length > 0 &&
                                                    <Col span={24} className={styles.bgTableBox}>
                                                        <Table
                                                            rowKey={(item, x) => {
                                                                return x
                                                            }}
                                                            className={styles.claimEdit}
                                                            dataSource={invoiceDates || []}
                                                            columns={claimDeskRights && claimDeskRights.viewByBranch ? branchColumns : columns}
                                                            scroll={{ x: claimDeskRights && claimDeskRights.viewByBranch ? 0 : 1500 }}
                                                            pagination={false}
                                                            border={true}
                                                        />
                                                    </Col>
                                                }

                                            </Row>
                                            <div style={{ textAlign: 'right', width: '100%' }}>
                                                <Button
                                                    type="primary"
                                                    htmlType="submit"
                                                    style={{
                                                        backgroundColor: '#85CF4A',
                                                        border: '1px solid #85CF4A',
                                                        color: 'white',
                                                        marginTop: '15px'
                                                    }}
                                                    loading={this.props.loading}>
                                                    Save
                                                </Button>
                                            </div>
                                        </div>
                                    }

                                </Col>
                            </Row>

                            <Drawer
                                title=""
                                forceRender={true}
                                placement="right"
                                closable={true}
                                onClose={() => {

                                    this.setState({
                                        visible: false,
                                        showBranchCommission: false,
                                        changeStatusValue: false
                                    })
                                    this.props.form.setFieldsValue({ branchCommission: '', status: '', comment: '' })
                                }}
                                visible={this.state.visible}
                                width={600}>
                                <div style={{ marginLeft: 20, marginRight: 20, marginTop: 20, textAlign: 'center' }}>
                                    <Form>
                                        <Row>

                                            <Col span={24}>

                                                <GetAllFormFields
                                                    apiurl={LAPI_URL}
                                                    inputSchema={commentBox}
                                                    getFieldDecorator={getFieldDecorator}
                                                    formItemLayout={formItemLayout}

                                                />
                                                <Form.Item>
                                                    <Button
                                                        type="primary"
                                                        htmlType="submit"
                                                        loading={this.props.loading}>
                                                        UPDATE
                                                    </Button>
                                                </Form.Item>

                                            </Col>

                                        </Row>
                                    </Form>

                                </div>

                            </Drawer>
                            <Row>
                                <Col span={24}>
                                    {claimDeskRights && !claimDeskRights.viewByBranch && (
                                        <Card
                                            title={<span style={{ color: "#fff" }}>Commission Details</span>}
                                            bordered={false}
                                            className="cardStyle"
                                        >

                                            {
                                                info && info.nextInvoiceGenerationDates
                                                    ? (() => {

                                                        var totalDebit = 0;
                                                        var totalCredit = 0;
                                                        var totalBalance = 0;
                                                        var tableCurrency = "";

                                                        var ledgerRows = [];
                                                        var runningBalance = 0;

                                                        info.nextInvoiceGenerationDates.forEach((invoice) => {

                                                            var generatedInvoices =
                                                                info &&
                                                                    info.generatedInvoices &&
                                                                    info.generatedInvoices.length > 0
                                                                    ? info.generatedInvoices
                                                                    : [];

                                                            var foundInvoice = null;

                                                            for (var i = 0; i < generatedInvoices.length; i++) {

                                                                if (
                                                                    generatedInvoices[i].invoiceNumber ===
                                                                    invoice.invoiceGeneratedNumber
                                                                ) {

                                                                    foundInvoice = generatedInvoices[i];
                                                                    // Do not break early, find the LAST match
                                                                }
                                                            }

                                                            var printInvoice = null;
                                                            var currency = "";
                                                            var status = "NA";

                                                            // =====================================
                                                            // UPLOADED INVOICE
                                                            // =====================================

                                                            if (invoice && invoice.uploaded) {

                                                                if (invoice && invoice.currency) {

                                                                    currency = invoice.currency;

                                                                } else if (
                                                                    foundInvoice &&
                                                                    foundInvoice.currency
                                                                ) {

                                                                    currency = foundInvoice.currency;

                                                                } else if (tableCurrency) {

                                                                    currency = tableCurrency;

                                                                } else {

                                                                    currency = "";
                                                                }

                                                                printInvoice = {
                                                                    commissionTotal: Number(
                                                                        invoice.commReceived || 0
                                                                    ),
                                                                    currency: currency
                                                                };

                                                                status =
                                                                    invoice.invoiceStatus
                                                                        ? invoice.invoiceStatus
                                                                        : "NA";
                                                            }

                                                            // =====================================
                                                            // GENERATED INVOICE
                                                            // =====================================

                                                            else if (
                                                                foundInvoice &&
                                                                foundInvoice.invoices &&
                                                                foundInvoice.invoices.length > 0
                                                            ) {

                                                                for (
                                                                    var j = 0;
                                                                    j < foundInvoice.invoices.length;
                                                                    j++
                                                                ) {

                                                                    if (
                                                                        String(
                                                                            foundInvoice.invoices[j]
                                                                                .invoiceGeneratedRecordId
                                                                        ) === String(invoice._id)
                                                                    ) {

                                                                        printInvoice =
                                                                            foundInvoice.invoices[j];

                                                                        break;
                                                                    }
                                                                }

                                                                currency =
                                                                    printInvoice &&
                                                                        printInvoice.currency
                                                                        ? printInvoice.currency
                                                                        : "";

                                                                let getStatusWeight = (s) => {
                                                                    const st = (s || '').toLowerCase().trim();
                                                                    if (['cleared', 'paid by uni', 'completed'].includes(st)) return 4;
                                                                    if (st === 'approved by uni') return 3;
                                                                    if (st === 'submitted to uni') return 2;
                                                                    if (st === 'generated') return 1;
                                                                    return 0;
                                                                };

                                                                let dbStatus = invoice.invoiceStatus || "Pending";
                                                                let genStatus = foundInvoice && foundInvoice.invoiceStatus ? foundInvoice.invoiceStatus : "Pending";

                                                                status = getStatusWeight(dbStatus) >= getStatusWeight(genStatus) ? dbStatus : genStatus;
                                                            }

                                                            if (!tableCurrency && currency) {
                                                                tableCurrency = currency;
                                                            }

                                                            var commissionTotal =
                                                                printInvoice &&
                                                                    printInvoice.commissionTotal
                                                                    ? Number(
                                                                        printInvoice.commissionTotal
                                                                    )
                                                                    : 0;

                                                            // =====================================
                                                            // BRANCH PLAN
                                                            // =====================================

                                                            if (
                                                                claimDeskRights &&
                                                                claimDeskRights.viewByBranch &&
                                                                this.state.branchPlan
                                                            ) {

                                                                var branchPlan =
                                                                    this.state.branchPlan;

                                                                if (
                                                                    branchPlan.commissionType ===
                                                                    'Flat'
                                                                ) {

                                                                    commissionTotal =
                                                                        Number(
                                                                            branchPlan.commission
                                                                        ) || 0;

                                                                } else if (
                                                                    branchPlan.commissionType ===
                                                                    'Percentage'
                                                                ) {

                                                                    var percent =
                                                                        Number(
                                                                            branchPlan.commission
                                                                        ) || 0;

                                                                    commissionTotal =
                                                                        (commissionTotal * percent)
                                                                        / 100;
                                                                }
                                                            }

                                                            var isCleared =
                                                                status === "Paid by Uni" ||
                                                                status === "Cleared";

                                                            // =====================================
                                                            // DEBIT ENTRY
                                                            // =====================================

                                                            runningBalance += commissionTotal;

                                                            totalDebit += commissionTotal;

                                                            ledgerRows.push({

                                                                key:
                                                                    invoice._id + "_debit",

                                                                term:
                                                                    invoice.invoiceNo || "NA",

                                                                invoiceDate:
                                                                    invoice &&
                                                                        invoice.generationDate
                                                                        ? invoice.generationDate
                                                                        : null,

                                                                invoiceNumber:
                                                                    invoice &&
                                                                        invoice.uploaded
                                                                        ? (
                                                                            invoice.cpInvoiceNumber
                                                                            || "NA"
                                                                        )
                                                                        : (
                                                                            invoice.invoiceGeneratedNumber
                                                                            || "NA"
                                                                        ),

                                                                debit:
                                                                    commissionTotal,

                                                                credit:
                                                                    0,

                                                                balance:
                                                                    runningBalance,

                                                                status:
                                                                    isCleared ? "Generated" : status,

                                                                currency:
                                                                    currency,

                                                                // =========================
                                                                // INVOICE URL
                                                                // =========================

                                                                invoiceUrl:
                                                                    invoice &&
                                                                        invoice.uploaded === true

                                                                        ? (
                                                                            invoice.cpUploadInvoice &&
                                                                                invoice.cpUploadInvoice.length > 0 &&
                                                                                invoice.cpUploadInvoice[0].url

                                                                                ? `${MEDIA_URL}/${invoice.cpUploadInvoice[0].url}`

                                                                                : null
                                                                        )

                                                                        : (
                                                                            foundInvoice &&
                                                                                foundInvoice.invoiceUrl

                                                                                ? `${MEDIA_URL}/${foundInvoice.invoiceUrl}`

                                                                                : null
                                                                        ),

                                                                paymentUrl:
                                                                    null

                                                            });

                                                            // =====================================
                                                            // CREDIT ENTRY
                                                            // =====================================

                                                            if (isCleared) {

                                                                runningBalance -= commissionTotal;

                                                                totalCredit += commissionTotal;

                                                                ledgerRows.push({

                                                                    key:
                                                                        invoice._id + "_credit",

                                                                    term:
                                                                        invoice.invoiceNo || "NA",

                                                                    invoiceDate:
                                                                        foundInvoice &&
                                                                            foundInvoice.invoiceReceivingDate
                                                                            ? foundInvoice.invoiceReceivingDate
                                                                            : (
                                                                                invoice.invoiceReceivedDate
                                                                                || invoice.generationDate
                                                                                || null
                                                                            ),

                                                                    invoiceNumber:
                                                                        invoice &&
                                                                            invoice.uploaded
                                                                            ? (
                                                                                invoice.cpInvoiceNumber
                                                                                || "NA"
                                                                            )
                                                                            : (
                                                                                invoice.invoiceGeneratedNumber
                                                                                || "NA"
                                                                            ),

                                                                    debit:
                                                                        0,

                                                                    credit:
                                                                        commissionTotal,

                                                                    balance:
                                                                        runningBalance,

                                                                    status:
                                                                        status,

                                                                    currency:
                                                                        currency,

                                                                    invoiceUrl:
                                                                        null,

                                                                    // =========================
                                                                    // PAYMENT RECEIPT URL
                                                                    // =========================

                                                                    paymentUrl:
                                                                        invoice &&
                                                                            invoice.uploaded === true

                                                                            ? (
                                                                                invoice.paymentReceipt &&
                                                                                    invoice.paymentReceipt.length > 0 &&
                                                                                    invoice.paymentReceipt[0].url

                                                                                    ? `${MEDIA_URL}/${invoice.paymentReceipt[0].url}`

                                                                                    : null
                                                                            )

                                                                            : (
                                                                                foundInvoice &&
                                                                                    foundInvoice.paymentReceipt &&
                                                                                    foundInvoice.paymentReceipt.length > 0 &&
                                                                                    foundInvoice.paymentReceipt[0].url

                                                                                    ? `${MEDIA_URL}/${foundInvoice.paymentReceipt[0].url}`

                                                                                    : null
                                                                            ),
                                                                });
                                                            }

                                                        });

                                                        totalBalance = runningBalance;

                                                        return (

                                                            <table>

                                                                <thead>

                                                                    <tr>

                                                                        <th>Term</th>

                                                                        <th>Invoice Date</th>
                                                                        {claimDeskRights && !claimDeskRights.viewByBranch && (
                                                                            <th>Invoice Number</th>
                                                                        )}

                                                                        <th>Debit</th>

                                                                        <th>Credit</th>

                                                                        <th>Balance</th>
                                                                        {claimDeskRights && !claimDeskRights.viewByBranch && (
                                                                            <th>Invoice Status</th>
                                                                        )}
                                                                    </tr>

                                                                </thead>

                                                                <tbody>

                                                                    {
                                                                        ledgerRows.map((row) => {

                                                                            return (

                                                                                <tr key={row.key}>

                                                                                    <td>
                                                                                        {row.term}
                                                                                    </td>

                                                                                    <td>

                                                                                        {
                                                                                            row.invoiceDate
                                                                                                ? moment(
                                                                                                    row.invoiceDate
                                                                                                ).format(
                                                                                                    dateFormat
                                                                                                )
                                                                                                : "NA"
                                                                                        }

                                                                                    </td>
                                                                                    {claimDeskRights && !claimDeskRights.viewByBranch && (
                                                                                        <td>
                                                                                            {
                                                                                                row.invoiceNumber
                                                                                            }
                                                                                        </td>
                                                                                    )}


                                                                                    <td>
                                                                                        {
                                                                                            formatAmount(
                                                                                                row.debit,
                                                                                                row.currency
                                                                                            )
                                                                                        }
                                                                                    </td>

                                                                                    <td>
                                                                                        {
                                                                                            formatAmount(
                                                                                                row.credit,
                                                                                                row.currency
                                                                                            )
                                                                                        }
                                                                                    </td>

                                                                                    <td
                                                                                        style={{
                                                                                            color:
                                                                                                row.balance === 0
                                                                                                    ? "#000"
                                                                                                    : "#ff4d4f"
                                                                                        }}
                                                                                    >

                                                                                        {
                                                                                            formatAmount(
                                                                                                row.balance,
                                                                                                row.currency
                                                                                            )
                                                                                        }

                                                                                    </td>

                                                                                    {claimDeskRights && !claimDeskRights.viewByBranch && (
                                                                                        <td
                                                                                            style={{
                                                                                                color:
                                                                                                    row.status === "Generated"
                                                                                                        ? "#f59e0b"
                                                                                                        : row.status === "Cleared"
                                                                                                            || row.status === "Paid by Uni"
                                                                                                            ? "#16a34a"
                                                                                                            : "#374151"
                                                                                            }}
                                                                                        >
                                                                                            <div
                                                                                                style={{
                                                                                                    display: "flex",
                                                                                                    alignItems: "center",
                                                                                                    gap: 6
                                                                                                }}
                                                                                            >

                                                                                                <span>
                                                                                                    {row.status}
                                                                                                </span>

                                                                                                {/* GENERATED INVOICE DOWNLOAD */}

                                                                                                {
                                                                                                    row.invoiceUrl
                                                                                                        ? (
                                                                                                            <Tooltip title="Download Invoice">

                                                                                                                <a
                                                                                                                    href={row.invoiceUrl}
                                                                                                                    target="_blank"
                                                                                                                    rel="noopener noreferrer"
                                                                                                                    style={{
                                                                                                                        color: "#f59e0b",
                                                                                                                        display: "flex",
                                                                                                                        alignItems: "center",
                                                                                                                        fontSize: 13
                                                                                                                    }}
                                                                                                                >

                                                                                                                    <FaDownload />

                                                                                                                </a>

                                                                                                            </Tooltip>
                                                                                                        )
                                                                                                        : null
                                                                                                }

                                                                                                {/* PAYMENT RECEIPT DOWNLOAD */}

                                                                                                {
                                                                                                    (
                                                                                                        row.status === "Cleared"
                                                                                                        ||
                                                                                                        row.status === "Paid by Uni"
                                                                                                    )
                                                                                                        &&
                                                                                                        row.paymentUrl
                                                                                                        ? (
                                                                                                            <Tooltip title="Download Payment Advice">

                                                                                                                <a
                                                                                                                    href={row.paymentUrl}
                                                                                                                    target="_blank"
                                                                                                                    rel="noopener noreferrer"
                                                                                                                    style={{
                                                                                                                        color: "#16a34a",
                                                                                                                        display: "flex",
                                                                                                                        alignItems: "center",
                                                                                                                        fontSize: 13
                                                                                                                    }}
                                                                                                                >

                                                                                                                    <FaDownload />

                                                                                                                </a>

                                                                                                            </Tooltip>
                                                                                                        )
                                                                                                        : null
                                                                                                }

                                                                                            </div>

                                                                                        </td>
                                                                                    )}

                                                                                </tr>
                                                                            );
                                                                        })
                                                                    }

                                                                </tbody>

                                                                <tfoot>

                                                                    <tr
                                                                        style={{
                                                                            fontWeight: "bold",
                                                                            background: "#fafafa"
                                                                        }}
                                                                    >

                                                                        <td
                                                                            colSpan={claimDeskRights && !claimDeskRights.viewByBranch ? 3 : 2}
                                                                            style={{
                                                                                textAlign: "right"
                                                                            }}
                                                                        >
                                                                            Total
                                                                        </td>

                                                                        <td>
                                                                            {
                                                                                formatAmount(
                                                                                    totalDebit,
                                                                                    tableCurrency
                                                                                )
                                                                            }
                                                                        </td>

                                                                        <td>
                                                                            {
                                                                                formatAmount(
                                                                                    totalCredit,
                                                                                    tableCurrency
                                                                                )
                                                                            }
                                                                        </td>

                                                                        <td
                                                                            style={{
                                                                                color:
                                                                                    totalBalance === 0
                                                                                        ? "#000"
                                                                                        : "#ff4d4f"
                                                                            }}
                                                                        >

                                                                            {
                                                                                formatAmount(
                                                                                    totalBalance,
                                                                                    tableCurrency
                                                                                )
                                                                            }

                                                                        </td>

                                                                        <td></td>

                                                                    </tr>

                                                                </tfoot>

                                                            </table>
                                                        );

                                                    })()
                                                    : null
                                            }

                                        </Card>
                                    )}

                                    {info && info.branchApInvoices && info.branchApInvoices.length > 0 && (
                                        <Card
                                            title={<span style={{ color: "#fff" }}>Branch Commission Ledger</span>}
                                            bordered={false}
                                            className="cardStyle"
                                        >
                                            {(() => {
                                                let totalDebit = 0;
                                                let totalCredit = 0;
                                                let tableCurrency = "";
                                                let ledgerRows = [];

                                                (info.branchApInvoices || []).forEach((claim) => {
                                                    const commissionTotal = Number(claim.commissionTotal || 0);
                                                    const sharingRate = parseFloat(String(claim.sharingRate || "0").replace("%", ""));
                                                    const amount = Number(((commissionTotal * sharingRate) / 100).toFixed(2));
                                                    const currency = claim.currency || "";

                                                    if (!tableCurrency && currency) {
                                                        tableCurrency = currency;
                                                    }

                                                    // 1. DEBIT ENTRY (Commission Earned) - Sort Order 1
                                                    // Hamesha created_at ki real date parse karein
                                                    const debitDate = claim.created_at && claim.created_at.$date ? claim.created_at.$date : claim.created_at;

                                                    ledgerRows.push({
                                                        key: `${claim._id || Math.random()}_debit`,
                                                        claimId: claim._id ? String(claim._id.$oid || claim._id) : "unknown",
                                                        rowType: "debit",
                                                        sortOrder: 1, // Strict priority over credit
                                                        date: debitDate,
                                                        refNo: claim.claimNumber || "-",
                                                        particulars: `Commission Earned (Term ${claim.termNumber || "-"})`,
                                                        debit: amount,
                                                        credit: 0,
                                                        currency,
                                                        status: (claim.status === "Paid" || (claim.invoice_details && claim.invoice_details.status === "Paid")) ? "Generated" : (claim.status || "Pending"),
                                                        invoiceUrl: claim.invoiceUrl ? `${MEDIA_URL}${claim.invoiceUrl}` : null,
                                                        paymentUrl: null
                                                    });

                                                    totalDebit += amount;

                                                    // 2. CREDIT ENTRY (Payment Released) - Sort Order 2
                                                    if (claim.status === "Paid" || (claim.invoice_details && claim.invoice_details.status === "Paid")) {
                                                        // Agar paymentDate available hai toh use karein, nahi toh updated_at ko fallback banayein
                                                        let creditDate = claim.updated_at && claim.updated_at.$date ? claim.updated_at.$date : claim.updated_at;
                                                        if (claim.invoice_details && claim.invoice_details.paymentDate) {
                                                            creditDate = claim.invoice_details.paymentDate.$date || claim.invoice_details.paymentDate;
                                                        }

                                                        ledgerRows.push({
                                                            key: `${claim._id || Math.random()}_credit`,
                                                            claimId: claim._id ? String(claim._id.$oid || claim._id) : "unknown",
                                                            rowType: "credit",
                                                            sortOrder: 2, // Secondary priority for same timestamp
                                                            date: creditDate,
                                                            refNo: claim.branchInvoiceNumber || claim.claimNumber || "-",
                                                            particulars: `Payment Released (Term ${claim.termNumber || "-"})`,
                                                            debit: 0,
                                                            credit: amount,
                                                            currency,
                                                            status: "Paid",
                                                            invoiceUrl: null,
                                                            paymentUrl: claim.invoice_details && claim.invoice_details.paymentReceipt ? `${MEDIA_URL}${claim.invoice_details.paymentReceipt[0].url}` : null
                                                        });

                                                        totalCredit += amount;
                                                    }
                                                });

                                                // FIXED SORTING LOGIC: Pehle actual timestamps compare honge, agar dates same hain toh sortOrder (debit pehle, credit baad me)
                                                ledgerRows.sort((a, b) => {
                                                    const dateA = new Date(a.date).getTime();
                                                    const dateB = new Date(b.date).getTime();

                                                    if (dateA === dateB) {
                                                        return a.sortOrder - b.sortOrder; // 1 (debit) hamesha 2 (credit) se pehle aayega
                                                    }
                                                    return dateA - dateB;
                                                });

                                                // RUNNING BALANCE CALCULATION (Ab ordered array pe correct sequence chalegi)
                                                let runningBalance = 0;
                                                ledgerRows = ledgerRows.map((row) => {
                                                    runningBalance = runningBalance + Number(row.debit || 0) - Number(row.credit || 0);
                                                    return { ...row, balance: runningBalance };
                                                });

                                                const totalBalance = runningBalance;

                                                return (
                                                    <div style={{ overflowX: 'auto' }}>
                                                        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                                            <thead>
                                                                <tr style={{ background: '#fafafa', borderBottom: '2px solid #f0f0f0' }}>
                                                                    <th style={styles.th}>Date</th>
                                                                    <th style={styles.th}>Ref No.</th>
                                                                    <th style={styles.th}>Particulars</th>
                                                                    <th style={styles.th}>Debit</th>
                                                                    <th style={styles.th}>Credit</th>
                                                                    <th style={styles.th}>Balance</th>
                                                                    <th style={styles.th}>Status/View</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {ledgerRows.map((row) => (
                                                                    <tr key={row.key} style={{ borderBottom: '1px solid #f0f0f0' }}>
                                                                        <td style={styles.td}>
                                                                            {row.date ? moment(row.date).format(dateFormat) : "NA"}
                                                                        </td>
                                                                        <td style={styles.td}>{row.refNo}</td>
                                                                        <td style={styles.td}>{row.particulars}</td>
                                                                        <td style={styles.td}>
                                                                            {row.debit > 0 ? formatAmount(row.debit, row.currency) : "-"}
                                                                        </td>
                                                                        <td style={styles.td}>
                                                                            {row.credit > 0 ? formatAmount(row.credit, row.currency) : "-"}
                                                                        </td>
                                                                        <td
                                                                            style={{
                                                                                ...styles.td,
                                                                                color: row.balance === 0 ? "#262626" : "#ff4d4f",
                                                                                fontWeight: "bold"
                                                                            }}
                                                                        >
                                                                            {formatAmount(row.balance, row.currency)}
                                                                        </td>
                                                                        <td style={styles.td}>
                                                                            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                                                                <span style={{ color: row.status === "Paid" ? "#52c41a" : "#faad14", fontWeight: 500 }}>
                                                                                    {row.status}
                                                                                </span>
                                                                                {row.invoiceUrl && (
                                                                                    <Tooltip title="Download Invoice">
                                                                                        <a href={row.invoiceUrl} target="_blank" rel="noopener noreferrer" style={{ color: "#faad14" }}>
                                                                                            <Icon type="download" />
                                                                                        </a>
                                                                                    </Tooltip>
                                                                                )}
                                                                                {row.status === "Paid" && row.paymentUrl && (
                                                                                    <Tooltip title="Download Payment Receipt">
                                                                                        <a href={row.paymentUrl} target="_blank" rel="noopener noreferrer" style={{ color: "#52c41a" }}>
                                                                                            <Icon type="download" />
                                                                                        </a>
                                                                                    </Tooltip>
                                                                                )}
                                                                            </div>
                                                                        </td>
                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                            <tfoot>
                                                                <tr style={{ fontWeight: "bold", background: "#fafafa", borderTop: '2px solid #f0f0f0' }}>
                                                                    <td colSpan={3} style={{ ...styles.td, textAlign: "right" }}>Total</td>
                                                                    <td style={styles.td}>{formatAmount(totalDebit, tableCurrency)}</td>
                                                                    <td style={styles.td}>{formatAmount(totalCredit, tableCurrency)}</td>
                                                                    <td style={{
                                                                        ...styles.td,
                                                                        color: Number(totalBalance) === 0 ? "#262626" : "#ff4d4f"
                                                                    }}>
                                                                        {formatAmount(totalBalance, tableCurrency)}
                                                                    </td>
                                                                    <td></td>
                                                                </tr>
                                                            </tfoot>
                                                        </table>
                                                    </div>
                                                );
                                            })()}
                                        </Card>
                                    )}

                                </Col>
                            </Row>
                        </Card>

                        {
                            generatedInvoice ?
                                <Card id='table_with_data' style={{ marginTop: '20px' }}>
                                    <table style={{ width: '100%' }}>
                                        <tbody>
                                            <tr>
                                                <td>
                                                    <ShowGeneratedInvoice generatedInvoice={generatedInvoice} />
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </Card>
                                : null
                        }

                    </Form>
                </Spin>

                <Drawer
                    title=""
                    placement="right"
                    closable={true}
                    id={'drawerCtrl'}
                    onClose={() => {
                        this.setState({
                            visible1: false
                        })
                    }}
                    visible={this.state.visible1}
                    width={1200}>
                    <div style={{ marginLeft: 20, marginRight: 20, marginTop: 20, textAlign: 'center' }}>
                        {this.state.visible1 &&
                            <GenerateInvoice inquiryId1={inquiryId} invoiceId1={this.state.invoiceId}
                                feedBack={async (values) => {
                                    this.setState({ visible1: false }, () => {
                                        this.setAgain(values)
                                    })
                                }} />}

                    </div>

                </Drawer>
                <Drawer
                    title=""
                    placement="right"
                    closable={true}
                    id={'drawerCtrl'}
                    onClose={() => {
                        this.setState({
                            visible2: false
                        })
                    }}
                    visible={this.state.visible2}
                    width={1200}>
                    <div style={{ marginLeft: 20, marginRight: 20, marginTop: 20, textAlign: 'center' }}>
                        {this.state.visible2 &&
                            <UpdateInvoice inquiryId1={inquiryId} dueInvoiceId1={this.state.dueInvoiceId}
                                feedBack={async (values) => {
                                    this.setState({ visible2: false }, () => {
                                        this.setAgain(values)
                                    })
                                }} />}

                    </div>

                </Drawer>
                <Drawer
                    title="Upload Branch/Sub Agent Invoice"
                    placement="right"
                    closable={true}
                    id={'drawerCtrl2'}
                    onClose={() => {
                        this.setState({
                            showGeneratedInvoiceData: false,
                            invoiceGeneratedId: '',
                            uploaded: false,
                        })
                    }}
                    visible={showGeneratedInvoiceData}
                    width={600}>
                    <Form onSubmit={this.handleSubmitAPInvoice} style={{ paddingRight: '50px' }}>
                        <GetAllFormFields
                            apiurl={LAPI_URL}
                            inputSchema={inputSchemaINV}
                            getFieldDecorator={getFieldDecorator}
                            formItemLayout={{
                                labelCol: { span: 16 },
                                wrapperCol: { span: 8 }
                            }}
                        />
                        <div style={{ textAlign: 'center', width: '100%' }}>
                            <Button
                                type="primary"
                                htmlType="submit"
                                style={{
                                    backgroundColor: '#85CF4A',
                                    border: '1px solid #85CF4A',
                                    color: 'white',
                                    marginTop: '15px'
                                }}
                                loading={this.props.loading}>
                                Save
                            </Button>
                        </div>
                    </Form>
                </Drawer>

                {/* Show Cp Invoice Upload */}
                <Drawer
                    title="Upload College/University/Channel Partner Invoice"
                    placement="right"
                    closable={true}
                    id={'drawerCtrl2'}
                    onClose={() => {
                        this.setState({
                            showGeneratedCPInvoiceData: false,
                            invoiceGeneratedId: '',
                            uploaded: false
                        })
                    }}
                    visible={showGeneratedCPInvoiceData}
                    width={600}>
                    <Card>
                        <Form onSubmit={this.handleSubmitCPInvoice} style={{ paddingRight: '50px' }}>
                            <GetAllFormFields
                                apiurl={LAPI_URL}
                                inputSchema={inputSchemaINCP}
                                getFieldDecorator={getFieldDecorator}
                                formItemLayout={{
                                    labelCol: { span: 16 },
                                    wrapperCol: { span: 8 }
                                }}
                            />
                            <div style={{ textAlign: 'center', width: '100%' }}>
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    style={{
                                        backgroundColor: '#85CF4A',
                                        border: '1px solid #85CF4A',
                                        color: 'white',
                                        marginTop: '15px'
                                    }}
                                    loading={this.props.loading}>
                                    Save
                                </Button>
                            </div>
                        </Form>
                    </Card>
                </Drawer>

            </PageHeaderWrapper >
        )
    }
}

const mapStateToProps = ({ global, router }) => ({
    loading: global.buttonLoading,
    categories: global.categories,
    allChannelPartners: global.allChannelPartners,
    search: router.location.search
})

const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ClaimProcessing)
